<template>
    <div id="non-printable-section" :class="{'tile-view full-height':!$root.dataObj.tableView}">
        <v-toolbar flat :height="56">
            <v-btn icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-btn>
            <v-toolbar-title>{{$route.query.reporttitle ? $route.query.reporttitle : $root.dataObj.reportTitle}}</v-toolbar-title>
            <v-spacer></v-spacer>

            <template v-if="$root.dataObj && $root.dataObj.reportData && $root.dataObj.reportData.detailRows">
              <v-btn class="mr-4" small outlined capitalize :disabled="exportExcel || loading" @click="fn_processDataForExcel">
                <img src="../../../assets/icon_excel.svg" style="width:20px;margin-right:8px"/> Export Excel
              </v-btn>

              <v-btn class="mr-4" small outlined capitalize v-if="reportId==801" :disabled="exportExcel || loading" @click="fn_getGSTPortalData">
                <img src="../../../assets/icon_excel.svg" style="width:20px;margin-right:8px"/> Export Excel for GST Portal
              </v-btn>

              <v-btn class="mr-4" small outlined capitalize :disabled="exportExcel || loading" @click="fn_export">
                <img src="../../../assets/icon_pdf_light.svg" style="width:20px;margin-right:8px"/> Export PDF
              </v-btn>

              <v-btn :class="{'mr-4':!$root.dataObj.hideFilterBtn && !$route.query.subreport}" small outlined capitalize :disabled="exportExcel || loading" @click="fn_action('printdatatable')">
                <v-icon left>print</v-icon> Print
              </v-btn>
            </template>

            <v-btn :disabled="exportExcel || loading" small outlined capitalize @click="fn_openFilter" v-if="!$root.dataObj.hideFilterBtn && !$route.query.subreport">
              <v-icon left>filter_list</v-icon> Filter
              <span style="font-size: 24px;position: absolute;bottom: 2px;right: -12px;color: #4b77be;" v-if="$root.reportFilterObj && Object.keys($root.reportFilterObj).length">&bull;</span>
            </v-btn>

            <!-- <v-btn color="success" @click="fn_exportTest">export test</v-btn> -->

        </v-toolbar>

        <v-divider></v-divider>

        <div class="report-container">

          <!-- {{$root.dataObj.reportData}} -->
            <template v-if="$root.dataObj.itemLabel">
              <v-row class="ma-0" id="item_selection_row">
                <v-cols class="pl-4 pt-1 pb-1">
                  <!-- <v-autocomplete
                    id="item_selection"
                    class="item_auto_complete"
                    ref="ref_itemSelection"
                    dense
                    :disabled="loading"
                    :items="$root.dataObj.itemLabel == 'Party'  ? parties : items"
                    :filter="$root.dataObj.itemLabel == 'Party' ? $root.customPartyFilter : $root.customItemFilter"
                    item-text="itemName"
                    item-value="itemId"
                    return-object
                    v-model="$root.dataObj.itemObj"
                    :placeholder="'Select '+$root.dataObj.itemLabel"
                    @input="fn_updateItem($root.dataObj.itemObj.itemId, $root.dataObj.itemObj.itemName)"
                    hide-details
                  ></v-autocomplete> -->
                  <v-autocomplete
                    id="item_selection"
                    class="item_auto_complete"
                    ref="ref_itemSelection"
                    dense
                    :disabled="loading"
                    :items="$root.dataObj.itemLabel == 'Party'  ? $root.ledgers : filteredProducts"
                    :filter="$root.dataObj.itemLabel == 'Party' ? $root.customPartyFilter : $root.customItemFilter"
                    item-text="itemName"
                    item-value="itemId"
                    return-object
                    v-model="$root.dataObj.itemObj"
                    :placeholder="'Select '+$root.dataObj.itemLabel"
                    @input="fn_updateItem($root.dataObj.itemObj.itemId, $root.dataObj.itemObj.itemName)"
                    hide-details
                  ></v-autocomplete>
                </v-cols>
              </v-row>
            </template>

            <template v-if="customDates">
              <v-row class="pa-3 pt-5">
                <v-col cols="12" sm="6" md="4">
                  <v-text-field cursor-pointer readonly hide-details :value="fn_getIndianFormatDate(selectedStartDate)" dense label="Date From" @click="fn_openDatePicker('start', $root.dataObj.startDate)"></v-text-field>
                  <div class="pt-2 redcolor" v-if="!isDateSelectionValid">
                      Invalid date selection
                  </div>
                  <div grey-back v-if="!isDateSelectionValid">
                      Note: Start date should be less than end date.
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field cursor-pointer readonly hide-details :value="fn_getIndianFormatDate(selectedEndDate)" dense label="Date To" @click="fn_openDatePicker('end', $root.dataObj.endDate)"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-btn small text color="primary" :disabled="!isDateSelectionValid" @click="fn_updateCustomDates">done</v-btn>
                  <v-btn class="ml-3" outlined text small color="primary" @click="customDates=false">cancel</v-btn>
                </v-col>
              </v-row>
            </template> 
            
            <report-template-container ref="ref_reportTemplateContainer" :reportId="reportId" :propsObj="$root.dataObj" :openDialogAndroid="fn_openDialogAndroid" :reportType="$root.dataObj.reportType" :getReportItemDetails="fn_getReportItemDetails" :openDatePicker="fn_openDatePicker" :reportFilterObj="$root.reportFilterObj" :openTransaction="fn_openTransaction" :openAccountDetails="fn_openAccountDetails" :tableView="$root.dataObj.tableView" :openLinkedAccount="fn_openLinkedAccount" :getSubReportData="fn_getSubReportData" :subReportData="subReportData" :periods="periods" :selectPeriod="fn_selectPeriod" :openDialogCustomDates="fn_openDialogCustomDates" :customDates="customDates" :getSubReportData2="fn_getSubReportData2" :subReportData2="subReportData2" :periodsLastDays="periodsLastDays" :selectDays="fn_selectDays" v-if="!loading"></report-template-container>

            <!-- <div>
              <v-progress-linear :value="loadingStatusObj.value" :height="4" color="primary"></v-progress-linear>

              <div right-align class="pr-2" v-if="loading">{{loadingStatusObj.value}}%</div>
            </div> -->

            <v-row class="fill-height" align-content="center" justify="center" style="position:absolute;top:0;bottom:0;width:100%" v-else>
              <v-col class="text-subtitle-1 text-center pb-0" cols="12">Generating report <template v-if="loadingStatusObj.value">{{loadingStatusObj.value}}%</template></v-col>
              <v-col cols="6">
                <v-progress-linear rounded :value="loadingStatusObj.value" :indeterminate="!loadingStatusObj.value || loadingStatusObj.value == 100 ? true : false" :height="6" color="primary"></v-progress-linear>
              </v-col>
            </v-row>

        </div>


        <v-snackbar v-model="snackbar">
          File downloaded!
          <v-btn text color="primary" @click.native="$root.fn_openDownloadedFile">Open</v-btn>
        </v-snackbar>

        <dialog-month-filter ref="ref_dialogMonthFilter" :selectPeriod="fn_selectPeriod"></dialog-month-filter>
        <dialog-quarter-filter ref="ref_dialogQuarterFilter" :selectPeriod="fn_selectPeriod"></dialog-quarter-filter>
        <dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker>
        <dialog-fy-filter ref="ref_dialogFiscalYearFilter" :selectPeriod="fn_selectPeriod"></dialog-fy-filter>
        <!-- <dialog-gstr-report ref="ref_gstrSubReport" :reportData="subReportData" :getSubReportData2="fn_getSubReportData2" :exportSubReport="fn_exportSubReport"></dialog-gstr-report> -->

        <!-- <dialog-gstr-report-2 ref="ref_gstrSubReport2" :reportData="subReportData2" :exportSubReport="fn_exportSubReport"></dialog-gstr-report-2> -->

        <dialog-comp-tax-rate ref="ref_dialogCompTaxRate" :openDialogTaxRateList="fn_openDialogTaxRateList"></dialog-comp-tax-rate>
        <dialog-tax-rate-list ref="ref_dialogTaxRateList" :taxRates="compTaxRateList" :selectedTaxRate="compTaxRate.value" :updateTaxRate="fn_updateTaxRate"></dialog-tax-rate-list>

        <!-- <dialog-period-selection ref="ref_dialogCustomPeriod" title="Select Period" :openDatePicker="fn_openDatePicker" :startDate="selectedStartDate" :endDate="selectedEndDate" :actionMethod="fn_updateCustomDates"></dialog-period-selection>

        <dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker>

        <dialog-share-options ref="ref_dialogShareOptions" :sharePdf="fn_action"></dialog-share-options>
        <dialog-linked-accounts ref="ref_dialogLinkedAccounts" :linkedAccounts="linkedAccounts" :getLinkedAccountDetails="fn_getLinkedAccountDetails"></dialog-linked-accounts>
        <dialog-gstr-report ref="ref_gstrSubReport" :reportData="subReportData"></dialog-gstr-report>
        <dialog-comp-tax-rate ref="ref_dialogCompTaxRate" :openDialogTaxRateList="fn_openDialogTaxRateList"></dialog-comp-tax-rate>
        <dialog-tax-rate-list ref="ref_dialogTaxRateList" :taxRates="compTaxRateList" :selectedTaxRate="compTaxRate.value" :updateTaxRate="fn_updateTaxRate"></dialog-tax-rate-list>

        <dialog-month-filter ref="ref_dialogMonthFilter" :selectPeriod="fn_selectPeriod"></dialog-month-filter>
        <dialog-quarter-filter ref="ref_dialogQuarterFilter" :selectPeriod="fn_selectPeriod"></dialog-quarter-filter>

        <v-bottom-sheet v-model="bottomSheet">
            <v-card v-if="detailReportObj" class="report-details-card">
              <v-card-text nopadding>
                <transaction-details ref="ref_transactionDetails" :propsObj="detailReportObj" :openTransaction="fn_openTransaction" :openAccountDetails="fn_openAccountDetails"></transaction-details>
              </v-card-text>
            </v-card>
        </v-bottom-sheet>

        <v-bottom-sheet v-model="filter_sheet">
          <filter-sheet ref="ref_filter" :applyFilter="fn_applyFilter" :openFilterDialog="fn_openFilterDialog" :closeFilters="fn_closeFilters" :closeDialog="fn_closeDialog" :propsObj="dataObj" :openDialogAndroid="fn_openDialogAndroid" :openDatePicker="fn_openDatePicker" :clearAllFilters="fn_clearAllFilters" :openDialogTaxRateList="fn_openDialogTaxRateList"></filter-sheet>
        </v-bottom-sheet>

        <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->

        <v-menu v-model="transactionDetails" :position-x="x" :position-y="y" absolute offset-y :close-on-click="false" style="background:#fff">
          <v-card>
            <v-subheader>
              <v-btn text color="primary" @click="fn_openTransaction(detailReportObj.transactionListId, detailReportObj.transactionId)">View Transaction</v-btn>
              <v-spacer></v-spacer>
              <v-btn icon @click="transactionDetails=false"><v-icon>close</v-icon></v-btn>
            </v-subheader>
            <v-divider></v-divider>
            <v-card-text class="pa-2">
              <transaction-details ref="ref_transactionDetails" :propsObj="detailReportObj" :openTransaction="fn_openTransaction" :openAccountDetails="fn_openAccountDetails"></transaction-details>
            </v-card-text>
          </v-card>
        </v-menu>

        <v-menu v-model="linkedAccountsMenu" :position-x="x" :position-y="y" absolute offset-y :close-on-click="false" style="background:#fff">
          <v-card>
            <!-- <v-subheader>
              <v-btn text color="primary" @click="fn_openTransaction(detailReportObj.transactionListId, detailReportObj.transactionId)">View Transaction</v-btn>
              <v-spacer></v-spacer>
              <v-btn icon @click="transactionDetails=false"><v-icon>close</v-icon></v-btn>
            </v-subheader>
            <v-divider></v-divider> -->
            <v-card-text nopadding>
              <!-- <transaction-details ref="ref_transactionDetails" :propsObj="detailReportObj" :openTransaction="fn_openTransaction" :openAccountDetails="fn_openAccountDetails"></transaction-details> -->
              <v-list nopadding>
                <template v-for="(item, index) in linkedAccounts">
                  <v-list-item :key="index" @click="fn_getLinkedAccountDetails(item)">
                    <v-list-item-content>
                      <v-list-item-title>{{item.accountName}}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <v-icon>chevron_right</v-icon>
                    </v-list-item-icon>
                  </v-list-item>
                  <v-divider :key="item.accountName" v-if="linkedAccounts.length-1 != index"></v-divider> 
                </template>
              </v-list>
            </v-card-text>
          </v-card>
        </v-menu>

        <v-navigation-drawer v-model="filter_sheet" :width="320" absolute right temporary>
          <filter-sheet ref="ref_filter" :applyFilter="fn_applyFilter" :openFilterDialog="fn_openFilterDialog" :closeFilters="fn_closeFilters" :closeDialog="fn_closeDialog" :propsObj="$root.dataObj" :openDialogAndroid="fn_openDialogAndroid" :openDatePicker="fn_openDatePicker" :clearAllFilters="fn_clearAllFilters" :openDialogTaxRateList="fn_openDialogTaxRateList" :filteredProducts="filteredProducts"></filter-sheet>
        </v-navigation-drawer>

        <dialog-loading ref="ref_dialogLoading" message="Generating Pdf..."></dialog-loading>

         <dialog-profit-loss-details ref="ref_dialogProfitLossDetails" :data="itemWiseProfitLossData" v-if="itemWiseProfitLossData"></dialog-profit-loss-details>
        <!-- <div id="content_div">
          <div style="color:red;white-space:nowrap"><p>A quick brown fox jumps over the lazy dog</p></div>
        </div> -->
    </div>
</template>


<script>

const dialogjs =  require('../../../dialog').dialogjs;
import reportTemplateContainer from './report_template_container'
// import dialogShareOptions from './dialogs/dialog_share_options'

// import dialogPeriodSelection from '../dialogs/dialog_period_selection'
import dialogDatepicker from '../../dialogs/dialog_datepicker'

// import dialogLinkedAccounts from './dialogs/dialog_linked_accounts'
// import dialogGstrReport from '../dialogs/dialog_gstr_report'
// import dialogGstrReport2 from '../dialogs/dialog_gstr_report_2'
import dialogCompTaxRate from '../dialogs/dialog_comp_tax_rate'
import dialogTaxRateList from '../dialogs/dialog_tax_rate_list'
import dialogMonthFilter from '../../dialogs/dialog_filter_months'
import dialogQuarterFilter from '../../dialogs/dialog_filter_quarter'
import dialogFyFilter from '../../dialogs/dialog_filter_fiscalyear'
import transactionDetails from '../report_templates/transaction_details'
// import {reportTableMixin} from './report_table_mixin.js'
import filters from './filters'

import dialogLoading from '../../dialogs/dialog_loading'
import dialogProfitLossDetails from '../dialogs/dialog_profit_loss_detail'

// import work from 'webworkify-webpack'

import { jsPDF } from "jspdf";
// import '../../../assets/rupeefont-normal.js'
// import '../../../assets/ascii-normal.js'
// import '../../../assets/IndianRupeeFont-3w4Z-normal.js'
import 'jspdf-autotable'
import '../../../assets/Hind-Regular-normal.js'
// import html2canvas from 'html2canvas'
// import * as htmlToImage from 'html-to-image';
// import { toPng } from 'html-to-image';

// const html2pdf = require('html2pdf/dist/html2pdf.js');

// import '../../../assets/ITF-Rupee-normal.js'

let dataConfig = null

const listIdObject = require('../../../config.js').configs.mastersPredefinedLists;
const accountGroupIds = require('../../../config.js').configs.accountGroupIds;
const transactionTypes = require('../../../config.js').configs.transactionTypes
const transactionForms = require('../../../config.js').configs.transactionForms
const reportList = require('../../../config.js').configs.reportList;
const transactionTypeForms = require('../../../config.js').configs.transactionTypeForms;

// const myworker = work(require.resolve('../../plugins/worker_prepare_excel_data.js'));

// import dialogPermission from '../dialogs/dialog_permission';

export default {
  // mixins: [reportTableMixin],
  data(){
    return{
        reportId:null,
        detailReportObj:null,
        dialogStorageId:null,
        snackbar:false,
        snackbar_msg:null,
        bottomSheet:false,
        dateType:null,
        selectedDate:null,
        filter_sheet:false,
        shareExcel:false,
        tileViewDetailSheet:false,
        tileViewTotalSheet:false,
        linkedAccounts:null,
        linkedAccountsMenu:null,
        subReportData:null,
        subReportData2:null,
        isGoBack:false,
        compTaxRateList:null,
        compTaxRate:{type:null, value:null},
        // selectedPeriod:null,
        periods:[
          {"title":"Today", "value":"currentDate"},
          {"title":"Yesterday", "value":"previousDate"},
          {"title":"This Month", "value":"month"},
          {"title":"Previous Month", "value":"previousMonth"},
          {"title":"Select Month", "value":"M"},
          {"title":"This Quarter", "value":"quarter"},

          {"title":"Select Quarter", "value":"Q"},
          {"title":"This Fiscal Year", "value":"year"},
          {"title":"Select Fiscal Year", "value":"FY"},
          {"title":"All Time", "value":"alltime"},
          {"title":"Custom", "value":null},
        ],
        selectedStartDate:null,
        selectedEndDate:null,
        customDates:false,
        testdata:null,
        items:[],
        parties:[],
        searchValue:'',
        loading:false,
        exportExcel:false,
        transactionDetails:false,
        x:0,
        y:0,
        loadingStatusObj:{value:0},
        itemWiseProfitLossData:null,
        periodsLastDays:[{'title':'7 Days', "value":7}, {'title':'15 Days', "value":15}, {'title':'30 Days', "value":30}, {'title':'45 Days', "value":45}, {'title':'90 Days', "value":90}],
    }
},
components:{
    'report-template-container': reportTemplateContainer,
    'dialog-datepicker': dialogDatepicker,
    'transaction-details': transactionDetails,
    'filter-sheet':filters,
    'dialog-comp-tax-rate':dialogCompTaxRate,
    'dialog-tax-rate-list':dialogTaxRateList,
    'dialog-month-filter': dialogMonthFilter,
    'dialog-quarter-filter': dialogQuarterFilter,
    'dialog-loading':dialogLoading,
    'dialog-profit-loss-details':dialogProfitLossDetails,
    'dialog-fy-filter':dialogFyFilter
},
methods:{

  fn_openFilter: function(){
        if(this.$route.params.reportId == 804){
            this.fn_openDialogTaxRateList();
        }
        else{
            this.filter_sheet = true;
            this.$refs['ref_filter'].fn_fetchFilterItems();
        }
  },

  fn_getIndianFormatDate: function(dataObj){
    return this.$moment(dataObj).format('DD-MMM-YYYY');
  },

  chunktest: function(){
    this.getData('ChunkTest', null, 
      {
        onSuccess: function(response){
          console.log(response);
        },
        onError: function(error){
            console.log(error);
        }
      }
    );
  },

    fn_postReportPreferences: function(reportId, valueObj){
      let self = this;
      let postObj = {};
      if(this.$root.dataObj.reportPreferences && this.$root.dataObj.reportPreferences.reportPreferenceId){
        postObj.reportPreferenceId = this.$root.dataObj.reportPreferences.reportPreferenceId;
      }
      else{
        postObj.reportPreferenceId = this.guid();
        // postObj.reportPreferenceId = await this.uniqueId();
      }
      
      postObj.reportId = reportId.toString();
      postObj.userId = null;
      postObj.value = JSON.stringify(valueObj);

      this.postData('ReportPreference', postObj, 
        {
          onSuccess: function(response){
            console.log(response);
            self.$root.dataObj.reportPreferences = {};
            self.$root.dataObj.reportPreferences.reportPreferenceId = postObj.reportPreferenceId;
            self.$root.dataObj.reportPreferences.reportId = postObj.reportId;
            self.$root.dataObj.reportPreferences.userId = postObj.userId;
            self.$root.dataObj.reportPreferences.value = valueObj;
            // self.$refs['ref_filter'].fn_updateItem(null, self.$root.dataObj.reportPreferences.value.taxRate, false, 'ref_compTaxRate');
            self.fn_updateFilterItem(null, self.$root.dataObj.reportPreferences.value.taxRate, false, 'ref_compTaxRate');
            // self.fn_getReportData();

          },
          onError: function(error){
              console.log(error);
          }
        }
      );
    },

    fn_getReportPreferences: function(reportId, itemId, itemName, to){
      let self = this;
      let reportIdStr = reportId.toString();
      this.getData('ReportPreference', reportIdStr, 
        {
          onSuccess: function(response){
            console.log(response);
            self.$root.dataObj.reportPreferences = JSON.parse(response);
            if(self.$root.dataObj.reportPreferences && self.$root.dataObj.reportPreferences.value){
              self.$root.dataObj.reportPreferences.value = JSON.parse(self.$root.dataObj.reportPreferences.value);
              self.compTaxRate.value = self.$root.dataObj.reportPreferences.value.taxRate;
              self.compTaxRate.type = self.$root.dataObj.reportPreferences.value.type;
            }
            else{
              self.$root.dataObj.reportPreferences = null;
            }

            self.fn_initializeData(itemId, itemName, to);
          },
          onError: function(error){
              console.log(error);
              self.loading = false;
          }
        }
      );
    },

    fn_getSubReportData: function(subReportId){
      if(!subReportId && this.$route.params.reportId != 803){
        return;
      }

      if(this.$route.params.reportId == 803){
        this.fn_generateDataForGSTR3B_subReport(subReportId);
        return;
      }

      this.loading = true;
      
      let subReportConfig = JSON.parse(JSON.stringify(require('../data_config/'+this.fn_getReportDataFileName()).data.fn_getData(subReportId)));

      this.fn_openGstrSubReport(subReportId, subReportConfig.reportTitle, 1);

      this.subReportData = {};
      this.subReportData.reportTitle = subReportConfig.reportTitle;

      console.log(JSON.stringify(subReportConfig));

      let filterObject = {};
      filterObject.gstrReportId = subReportId;
      filterObject.startDate = this.$moment(this.$root.dataObj.startDate).startOf('day');//new Date(this.$root.dataObj.startDate);
      filterObject.endDate = this.$moment(this.$root.dataObj.endDate).endOf('day');

      filterObject.startDate = this.$root.fn_getLocalDateFormat(filterObject.startDate);
      filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);

      let self = this;
      this.getReportData('GstrSubReport', this.$root.CurrentBusiness.StateID, filterObject, this.loadingStatusObj,{
        onSuccess: function(response){
          console.log(response);
          self.subReportData = JSON.parse(response);
          self.subReportData.reportTitle = subReportConfig.reportTitle;
          self.subReportData.headerRow = subReportConfig.headerRow;
          self.subReportData.headerRowArr = subReportConfig.headerRowTableHeaders;
          self.subReportData.columns = subReportConfig.columns;
          self.subReportData.internalHeaderRow = subReportConfig.internalHeaderRow;
          self.subReportData.internalHeaderRowArr = subReportConfig.internalHeaderRowArr;
          self.subReportData.internalColumns = subReportConfig.internalColumns;
          self.subReportData.startDate = self.$route.query.startDate;
          self.subReportData.endDate = self.$route.query.endDate;
          console.log(JSON.stringify(self.subReportData));

          if((subReportId == 'GSTR1HSN' || subReportId == 'GSTR2HSN') && self.subReportData.data && self.subReportData.data.detailRows && self.subReportData.data.detailRows.length){
            for(let i=0; i<self.subReportData.data.detailRows.length; i++){
              if(self.subReportData.data.detailRows[i].cols.unitQtyCode == 45){
                self.subReportData.data.detailRows[i].cols.unitQtyCode = 'LTR-LITRES';
              }
            }
          }

          self.loading = false;
          // self.fn_openGstrSubReport();
        }, 
        onError: function(error){
          console.log(error);
          self.loading = false;
          // self.hideLoading();
        }

      });
    },

    fn_getSubReportData2: function(subReportId){

    //   this.fn_openGstrSubReport2();

      this.loading = true;

      let subReportConfig = JSON.parse(JSON.stringify(require('../data_config/'+this.fn_getReportDataFileName()).data.fn_getData(subReportId)));

      console.log(JSON.stringify(subReportConfig));

      this.fn_openGstrSubReport(subReportId, subReportConfig.reportTitle, 2);

      this.subReportData2 = {};
      this.subReportData2.reportTitle = subReportConfig.reportTitle;

      let filterObject = {};
      filterObject.gstrReportId = subReportId;
      filterObject.startDate = this.$moment(this.$root.dataObj.startDate).startOf('day');//new Date(this.$root.dataObj.startDate);
      filterObject.endDate = this.$moment(this.$root.dataObj.endDate).endOf('day');

      filterObject.startDate = this.$root.fn_getLocalDateFormat(filterObject.startDate);
      filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);

      let self = this;
      this.getReportData('GstrSubReport', this.$root.CurrentBusiness.StateID, filterObject, this.loadingStatusObj,{
        onSuccess: function(response){
          console.log(response);
          self.subReportData2 = JSON.parse(response);
          self.subReportData2.reportTitle = subReportConfig.reportTitle;
          self.subReportData2.headerRow = subReportConfig.headerRow;
          self.subReportData2.headerRowArr = subReportConfig.headerRowTableHeaders;
          self.subReportData2.columns = subReportConfig.columns;
          self.subReportData2.internalHeaderRow = subReportConfig.internalHeaderRow;
          self.subReportData2.internalHeaderRowArr = subReportConfig.internalHeaderRowArr;
          self.subReportData2.internalColumns = subReportConfig.internalColumns;
          self.subReportData2.startDate = self.$route.query.startDate;
          self.subReportData2.endDate = self.$route.query.endDate;
          console.log(JSON.stringify(self.subReportData2));
          self.loading = false;
        }, 
        onError: function(error){
          console.log(error);
          self.loading = false;
        }

      });
    },

    fn_generateDataForGSTR3B_subReport: function(item){
        

      console.log(item);

      this.fn_openGstrSubReport(item.subReportId, item.title, 1);

      this.subReportData = {};
      this.subReportData.data = {};
      this.subReportData.data.detailRows = [];

      // this.subReportData = item.subreportData;
      this.subReportData.data.detailRows = this.$root.dataObj.reportData.detailRows.filter(subReportItem=>{
        if(item.section == '3.2'){
          return subReportItem.section == item.section && !subReportItem.mainRow && (subReportItem.cols.otherTax && subReportItem.cols.otherTax.items && subReportItem.cols.otherTax.items.length);
        }
        else{
          return subReportItem.section == item.section && !subReportItem.mainRow
        }
      })

      this.subReportData.reportTitle = item.title;
      this.subReportData.startDate = this.$route.query.startDate;
      this.subReportData.endDate = this.$route.query.endDate;

      if(item.section == '3.1'){

        this.subReportData.headerRow = {"natureOfSupplies":"Nature of Supplies", "taxableValue":"Total Taxable Value", "igst":"Integrated Tax", "cgst":"Central Tax", "sgst":"State/UT Tax", "cess":"CESS"};
        this.subReportData.headerRowArr = [{"headerName":"Nature of Supplies","type":"string"}, {"headerName":"Total Taxable Value","type":"number"}, {"headerName":"Integrated Tax","type":"number"}, {"headerName":"Central Tax","type":"number"}, {"headerName":"State/UT Tax","type":"number"}, {"headerName":"CESS","type":"number"}];
        this.subReportData.columns = ["natureOfSupplies", "taxableValue", "igst", "cgst", "sgst", "cess"];
      }
      else if(item.section == '3.2'){
        this.subReportData.headerRow = {"natureOfSupplies":"Nature of Supplies"};
        this.subReportData.headerRowArr = [{"headerName":"Nature of Supplies","type":"string"}];
        this.subReportData.columns = ["natureOfSupplies"];

        this.subReportData.internalHeaderRow = {"placeOfSupply":"Place of Supply (State/UT)", "taxableValue":"Total Taxable Value", "igst":"Amount of Tax"};
        this.subReportData.internalHeaderRowArr = [{"headerName":"Place of Supply (State/UT)","type":"string"},{"headerName":"Total Taxable Value","type":"number"},{"headerName":"Amount of Tax","type":"number"}];
        this.subReportData.internalColumns = ["placeOfSupply", "taxableValue", "igst"];
      }
      else if(item.section == '4'){
        this.subReportData.headerRow = {"natureOfSupplies":"Details", "igst":"Integrated Tax", "cgst":"Central Tax", "sgst":"State/UT Tax", "cess":"CESS"};
        this.subReportData.headerRowArr = [{"headerName":"Details","type":"string"}, {"headerName":"Integrated Tax","type":"number"}, {"headerName":"Central Tax","type":"number"}, {"headerName":"State/UT Tax","type":"number"}, {"headerName":"CESS","type":"number"}];
        this.subReportData.columns = ["natureOfSupplies", "igst", "cgst", "sgst", "cess"];
      }
      else if(item.section == '5'){
        this.subReportData.headerRow = {"natureOfSupplies":"Nature of Supplies", "interStateAmount":"Inter-State Supplies", "intraStateAmount":"Intra-State Supplies"};
        this.subReportData.headerRowArr = [{"headerName":"Nature of Supplies","type":"string"}, {"headerName":"Inter-State Supplies","type":"number"}, {"headerName":"Intra-State Supplies","type":"number"}];
        this.subReportData.columns = ["natureOfSupplies", "interStateAmount", "intraStateAmount"];
      }
      if(item.section == '5.1'){
        this.subReportData.headerRow = {"natureOfSupplies":"Nature of Supplies", "igst":"Integrated Tax", "cgst":"Central Tax", "sgst":"State/UT Tax", "cess":"CESS"};
        this.subReportData.headerRowArr = [{"headerName":"Nature of Supplies","type":"string"}, {"headerName":"Integrated Tax","type":"number"}, {"headerName":"Central Tax","type":"number"}, {"headerName":"State/UT Tax","type":"number"}, {"headerName":"CESS","type":"number"}];
        this.subReportData.columns = ["taxableValue", "igst", "cgst", "sgst", "cess"];
      }

      console.log(JSON.stringify(this.subReportData));
      // this.fn_openGstrSubReport();

      // self.subReportData = JSON.parse(response);
      // self.subReportData.reportTitle = subReportConfig.reportTitle;
      // self.subReportData.headerRow = subReportConfig.headerRow;
      // self.subReportData.headerRowArr = subReportConfig.headerRowTableHeaders;
      // self.subReportData.columns = subReportConfig.columns;

      // reportTitle:"Summary For HSN(12)",
      // headerRow:{"hsnCode":"HSN", "description":"Description", "unitQtyCode":"UQC", "qty":"Total Quantity", "value":"Total Value (₹)", "taxableValue":"Total Taxable Value (₹)", "igst":"Integrated Tax (₹)", "cgst":"Central Tax (₹)", "stgst":"State/UT Tax (₹)", "cess":"CESS (₹)"},

      // headerRowTableHeaders:[{"headerName":"HSN","type":"string"},{"headerName":"Description","type":"string"},{"headerName":"UQC","type":"string"},{"headerName":"Total Quantity","type":"number"},{"headerName":"Total Value (₹)","type":"number"},{"headerName":"Total Taxable Value (₹)","type":"number"},{"headerName":"Integrated Tax (₹)","type":"number"},{"headerName":"Central Tax (₹)","type":"number"},{"headerName":"State/UT Tax (₹)","type":"number"},{"headerName":"CESS (₹)","type":"number"}],

      // columns:['hsnCode', 'description', 'unitQtyCode', 'qty', 'value', 'taxableValue', 'igst', 'cgst', 'stgst', 'cess'],

    },

    fn_openGstrSubReport: function(subReportId, title, level){
      // this.fn_openDialogWeb('web', 'GstrSubReport', 'ref_gstrSubReport');
    //   this.$refs['ref_gstrSubReport'].openDialogWeb();
        localStorage.setItem("clearfilters", 1);
        let startDate = this.$moment(this.$root.dataObj.startDate).startOf('day').toISOString();
        let endDate = this.$moment(this.$root.dataObj.endDate).endOf('day').toISOString();
        this.$router.push({path:"/"+this.$root.CurrentBusiness.BusinessID+"/reports/"+subReportId, query:{subreport:level, reporttitle:title, startDate:startDate, endDate:endDate}});
    },

    // fn_openGstrSubReport2: function(){
    //   this.$refs['ref_gstrSubReport2'].openDialogWeb();
    // },

    fn_openLinkedAccount: function(e, linkedAccounts){

      e.preventDefault();

      this.linkedAccountsMenu = false;

      if(!linkedAccounts){
        return
      }

      if(linkedAccounts.length==1){
        this.fn_getLinkedAccountDetails(linkedAccounts[0]);
      }
      else{
        this.linkedAccounts = linkedAccounts;
        this.x = e.clientX;
        this.y = e.clientY;
        this.$nextTick(() => {
          this.linkedAccountsMenu = true;
        })
      }
      
      // this.fn_openDialogWeb('web', 'LinkedAccounts', 'ref_dialogLinkedAccounts');
    },

    fn_getLinkedAccountDetails: function(item){
      this.fn_closeDialog();
      let self = this;
      setTimeout(function(){
        self.$refs['ref_reportTemplateContainer'].$refs['ref_generalReport'].fn_getDetails(null, item, true);
      },300)
    },

    fn_openDialogShareOptions: function(){
        this.fn_openDialogWeb('web', 'Filter', 'ref_dialogShareOptions');
    },

    fn_closeFilters: function(){
      this.filter_sheet = false;
    },

    fn_openDialogCustomDates: function(){
        this.selectedStartDate = this.$root.dataObj.startDate;
        this.selectedEndDate = this.$root.dataObj.endDate;
        this.customDates = true;
        // this.fn_openDialogWeb('web', 'CustomPeriod', 'ref_dialogCustomPeriod');
    },

    fn_openDatePicker: function (type, date) {
      let self = this;
      this.dateType = type;
      this.selectedDate = date;
      setTimeout(function () {
        // self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker');
        self.$refs['ref_dialogDatePicker'].openDialogWeb();
      })
    },

    // fn_updateDate: function (value) {
    //   this.fn_closeDialog();

    //   if(this.dateType=="start"){
    //     this.$root.dataObj.startDate = value;
    //   }
    //   else if(this.dateType=="end"){
    //     this.$root.dataObj.endDate = value;
    //   }

    //   this.$root.dataObj.selectedPeriod = null;

    //   let localDateObj = {};
    //   localDateObj.startDate = this.$root.dataObj.startDate ? this.$root.dataObj.startDate : null;
    //   localDateObj.endDate = this.$root.dataObj.endDate;
    //   localDateObj.selectedPeriod = this.$root.dataObj.selectedPeriod ? this.$root.dataObj.selectedPeriod : null;
    //   localStorage.setItem('report_period_'+this.$route.params.reportId, JSON.stringify(localDateObj));

    //   this.fn_getReportData();

    //   let self = this;
    //   setTimeout(function(){
    //     self.$refs['ref_dialogDatePicker'].disableBtn = false;
    //   }, 1000);
    // },

    fn_updateDate: function (value) {
      // this.fn_closeDialog();
      this.$refs['ref_dialogDatePicker'].closeDialogWeb();

      if(this.dateType=="start"){
        this.selectedStartDate = value;
      }
      else if(this.dateType=="end"){
        this.selectedEndDate = value;
      }

      if(this.$root.dataObj.periodLabel == 'As On'){
        this.fn_updateCustomDates();
      }

      let self = this;
      setTimeout(function(){
        self.$refs['ref_dialogDatePicker'].disableBtn = false;
      }, 1000);

      // this.dialog_datepicker = false;

      // this.fn_getDashboardData();
    },

    fn_updateCustomDates: function(){
    //   this.$root.dataObj.startDate = this.selectedStartDate;
    //   this.$root.dataObj.endDate = this.selectedEndDate;
      this.selectedStartDate ? this.$root.dataObj.startDate = this.selectedStartDate : '';
      this.selectedEndDate ? this.$root.dataObj.endDate = this.selectedEndDate : '';
      this.$root.dataObj.selectedPeriod = null;

      this.customDates = false;

      let localDateObj = {};
      localDateObj.startDate = this.$root.dataObj.startDate ? this.$root.dataObj.startDate : null;
      localDateObj.endDate = this.$root.dataObj.endDate;
      localDateObj.selectedPeriod = this.$root.dataObj.selectedPeriod ? this.$root.dataObj.selectedPeriod : null;
      localStorage.setItem('report_period_'+this.$route.params.reportId, JSON.stringify(localDateObj));

      this.$root.dataObj.selectedPeriod = "Custom";

      this.fn_getReportData();
    },

    fn_openDialogMonthFilter: function(){
      this.$refs['ref_dialogMonthFilter'].openDialogWeb();
      // this.fn_openDialogWeb('web', 'MonthFilter', 'ref_dialogMonthFilter');
    },

    fn_openDialogQuarterFilter: function(){
      this.$refs['ref_dialogQuarterFilter'].openDialogWeb();
      // this.fn_openDialogWeb('web', 'QuarterFilter', 'ref_dialogQuarterFilter');
    },
    
    fn_openDialogFyfilter: function(){
      this.$refs['ref_dialogFiscalYearFilter'].openDialogWeb();
    },

    fn_selectPeriod: function(type, month, year){
      if(!type){
        this.fn_openDialogCustomDates();
        return;
      }

      if(type=='M'){
        this.fn_openDialogMonthFilter();
      }
      else if(type=='Q'){
        this.fn_openDialogQuarterFilter();
      }
      else if(type=='FY'){
        this.fn_openDialogFyfilter();
      }
      else{
        // this.fn_closeDialog(); 
        this.$refs['ref_dialogMonthFilter'].closeDialogWeb();
        this.$refs['ref_dialogQuarterFilter'].closeDialogWeb();
        this.$refs['ref_dialogFiscalYearFilter'].closeDialogWeb();

        let previousDateSelected = false;

        // Date validation if selected before opening date
        if(type == "previousMonth"){
          let now = new Date();
          let previousMonthDate = new Date(now.getFullYear(), now.getMonth(), 0);
          if(previousMonthDate.getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
            previousDateSelected = true;
          }
        }

        if(type == "previousDate"){
          let now = new Date();
          let yesterday = new Date(now.setDate(now.getDate() - 1));
          if(yesterday.getTime() < new Date(this.$root.CurrentBusiness.OpeningDate).getTime()){
            previousDateSelected = true;
          }
        }

        if(previousDateSelected){
          this.$eventHub.$emit('snackbarAlert', {msg:'Not Applicable'});
          return;
        }
        // Date validation end if selected before opening date
        
        let dateObj = this.fn_getTimeSpan(type, month, year);

        this.$root.dataObj.startDate = dateObj.startDate;
        this.$root.dataObj.endDate = dateObj.endDate;

        let localDateObj = {};
        // localDateObj.startDate = this.$root.dataObj.startDate ? new Date(this.$root.dataObj.startDate) : null;
        localDateObj.startDate = this.$root.dataObj.startDate ? this.$root.dataObj.startDate : null;
        // localDateObj.endDate = new Date(this.$root.dataObj.endDate);
        localDateObj.endDate = this.$root.dataObj.endDate;
        localDateObj.selectedPeriod = this.$root.dataObj.selectedPeriod ? this.$root.dataObj.selectedPeriod : null;
        localStorage.setItem('report_period_'+this.$route.params.reportId, JSON.stringify(localDateObj));

        this.fn_getReportData();
      }
    },

    fn_selectDays: function(item){
      this.$root.dataObj.selectedPeriod = item.title;
      let date = new Date();
      this.$root.dataObj.endDate = new Date(date.setDate(date.getDate() + item.value));
      this.fn_getReportData();
    },

    fn_getReportData: function(filterObj){
        this.loading = true;
        // this.showLoading('Preparing report...');
        let filterObject = {};

        !this.reportId ? this.reportId = this.$route.params.reportId : '';

        // filterObj ? this.$root.reportFilterObj = filterObj : '';
        if(filterObj){
          this.$root.reportFilterObj = filterObj;
        }
        else if(localStorage.getItem("report_filter_"+this.reportId)){
         this.$root.reportFilterObj = JSON.parse(localStorage.getItem("report_filter_"+this.reportId)); 
        }

        filterObject.reportId = this.reportId;

        if(localStorage.getItem('period_'+this.reportId)){
          let periodObj = JSON.parse(localStorage.getItem('period_'+this.reportId));
          this.$root.dataObj.startDate = periodObj.startDate;
          this.$root.dataObj.endDate = periodObj.endDate;
        }

        // filterObject.startDate = new Date(this.$root.dataObj.startDate);
        // filterObject.startDate = this.$moment(this.$root.dataObj.startDate).startOf('day');
        // filterObject.endDate = this.$moment(this.$root.dataObj.endDate).endOf('day');
        filterObject.startDate = this.$root.dataObj.startDate ? this.$moment(this.$root.dataObj.startDate).startOf('day') : null;
        filterObject.endDate = this.$moment(this.$root.dataObj.endDate).endOf('day');

        filterObject.startDate = filterObject.startDate ? this.$root.fn_getLocalDateFormat(filterObject.startDate) : null;
        filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);

        if(this.reportId==304 || this.reportId==404){
          filterObject.transactionListId = this.reportId==304 ? [transactionTypes.deliveryChallan.id] : [transactionTypes.purchaseChallan.id];
          !this.$root.reportFilterObj.status ? this.$root.reportFilterObj.status = {"id":null, "name":"Status", "value":"All"} : '';
        }
        else if(this.reportId==305 || this.reportId==405 || this.reportId==311 || this.reportId==418){
          filterObject.transactionListId = this.reportId==305 || this.reportId==311 ? [transactionTypes.order.id] : [transactionTypes.purchaseOrder.id];
          !this.$root.reportFilterObj.status ? this.$root.reportFilterObj.status = {"id":null, "name":"Status", "value":"All"} : '';
        }
        else if(this.reportId==503){
          !this.$root.reportFilterObj.groupTypeId ? this.$root.reportFilterObj.groupTypeId = {"id":null, "name":"Type", "value":"All"} : '';
        }
        else if(this.reportId==406){
          filterObject.accountGroups = [accountGroupIds.purchaseAccount.id];
        }
        else if(this.reportId==412 || this.reportId==413 || this.reportId==414){
          filterObject.transactionListId = [20005];
        }

        // if(this.reportId == 804 && this.$root.dataObj.reportPreferences && this.$root.dataObj.reportPreferences.value){
        //   filterObject.taxRate = this.$root.dataObj.reportPreferences.value;
        // }

        //Advance Filters
        if(Object.keys(this.$root.reportFilterObj).length){
          if(this.$root.reportFilterObj.party)
            filterObject.partyId = this.$root.reportFilterObj.party.id;
          if(this.$root.reportFilterObj.product)
            filterObject.productId = this.$root.reportFilterObj.product.id;
          if(this.$root.reportFilterObj.brand)
            filterObject.brandId = this.$root.reportFilterObj.brand.id;
          if(this.$root.reportFilterObj.category)
            filterObject.categoryId = this.$root.reportFilterObj.category.id;
          if(this.$root.reportFilterObj.taxType)
            filterObject.taxTypeId = this.$root.reportFilterObj.taxType.id;
          if(this.$root.reportFilterObj.transactionTypeForm)
            filterObject.transactionTypeFormId = this.$root.reportFilterObj.transactionTypeForm.id;
          if(this.$root.reportFilterObj.accountGroup)
            filterObject.accountGroups = [this.$root.reportFilterObj.accountGroup.id];
          if(this.$root.reportFilterObj.prescriber)
            filterObject.prescribedToId = this.$root.reportFilterObj.prescriber.id;
          if(this.$root.reportFilterObj.salesman)
            filterObject.salesmanId = this.$root.reportFilterObj.salesman.id;
          if(this.$root.reportFilterObj.broker)
            filterObject.brokerId = this.$root.reportFilterObj.broker.id;
          if(this.$root.reportFilterObj.status)
            filterObject.status = this.$root.reportFilterObj.status.value;
          if(this.$root.reportFilterObj.groupTypeId)
            filterObject.groupTypeId = this.$root.reportFilterObj.groupTypeId.value == 'Receivables' ? 101 : this.$root.reportFilterObj.groupTypeId.value == 'Payables' ? 102 : null;
          if(this.$root.reportFilterObj.taxRate)
            filterObject.taxRate = this.$root.reportFilterObj.taxRate.value;
          if(this.$root.reportFilterObj.showOutOfStock)
            filterObject.showOutOfStock = this.$root.reportFilterObj.showOutOfStock.value;
          if(this.$root.reportFilterObj.dueDays)
            filterObject.dueDays = this.$root.reportFilterObj.dueDays.value;
          if(this.$root.reportFilterObj.showMSME)
            filterObject.showMSME = this.$root.reportFilterObj.showMSME.value;
          if(this.$root.reportFilterObj.showAllBatch)
            filterObject.showExpireBatch = this.$root.reportFilterObj.showAllBatch.value;
          if(this.$root.reportFilterObj.batchExpireIn)
            filterObject.noOfDaysToExpire = this.$root.reportFilterObj.batchExpireIn.value == 'Today' ? 0 : Number(this.$root.reportFilterObj.batchExpireIn.value.substring(0, this.$root.reportFilterObj.batchExpireIn.value.indexOf(' ')));
          if(this.$root.reportFilterObj.inventoryType)
            filterObject.groupTypeId = this.$root.reportFilterObj.inventoryType.value == 'Goods' ? 101 : this.$root.reportFilterObj.inventoryType.value == 'Service' ? 102 : null;
          if(this.$root.reportFilterObj.godown)
            filterObject.godownId = this.$root.reportFilterObj.godown.id;
          if(this.$root.reportFilterObj.parties)
            filterObject.partyId = JSON.stringify({"SelectedItems":this.$root.reportFilterObj.parties});
          if(this.$root.reportFilterObj.stockType)
            filterObject.qtyFilterMode = this.$root.reportFilterObj.stockType.value == 'All' ? 3 : filterObject.stockType = this.$root.reportFilterObj.stockType.value == 'Positive' ? 1 : filterObject.stockType = this.$root.reportFilterObj.stockType.value == 'Negative' ? 2 : 0;
          if(this.$root.reportFilterObj.stockSummarySortBy)
            filterObject.sortMode = this.$root.reportFilterObj.stockSummarySortBy.value == 'Product Name' ? 0 : this.$root.reportFilterObj.stockSummarySortBy.value == 'Category Name' ? 1 : null;
          if(this.$root.reportFilterObj.showZeroBalanceLedgers)
            filterObject.showZeroBalanceLedgers = this.$root.reportFilterObj.showZeroBalanceLedgers.value;
        }

        let itemId = null;

        if(this.reportId == 801 || this.reportId == 802 || this.reportId == 803 || this.reportId == 804){
          itemId = this.$root.CurrentBusiness.StateID;
        }
        else{
          itemId = this.$root.dataObj.itemId;
        }
        
        console.log(JSON.stringify(filterObject));
        let self = this;
        // let dataObj = {"name":"Report", "itemId":null, "filterObject":"{'reportId':"+this.$route.params.reportId+", 'startDate':'2021-04-01T00:00:00.0','endDate':'2021-12-31T23:59:59.999'}", "postData":null, "requestId":null};
        // this.getReportData('Report', dataObj, 
        //     {
        //         onSuccess: function(response){
        //             console.log(response);
        //             let reportData = JSON.parse(response);
        //             self.fn_removeMrpColumn(reportData.data);
        //         }, 
        //         onError: function(error){
        //             console.log(error);
        //         }
        //     }
        // );
        this.subReportData = null;
        this.subReportData2 = null;

        // date calculation to include or not include income,expense openings in next fiscal year
        let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
        let openingYear = openingDate.getFullYear();
        let openingMonth = openingDate.getMonth() + 1;

        let openingFY = openingMonth <= 3 ? (openingYear - 1) : openingYear;

        let selectedStartDate = new Date(filterObject.startDate);
        let selectedStartDateYear = selectedStartDate.getFullYear();
        let selectedStartDateMonth = selectedStartDate.getMonth() + 1;

        let selectedStartDateFY = selectedStartDateMonth <= 3 ? (selectedStartDateYear - 1) : selectedStartDateYear;

        filterObject.includeOpening = true;
        if(selectedStartDateFY > openingFY){
          filterObject.includeOpening = false;
        }

        if((this.reportId == 201 || this.reportId == 601 || this.reportId == 602) && selectedStartDate > openingDate && selectedStartDateFY == openingFY){
          filterObject.includeOpening = false;
        }

        if(this.reportId == 102 || this.reportId == 601 || this.reportId == 602 || this.reportId == 603 || this.reportId == 901){
          filterObject.GSTRegistrationStatus = this.$root.CurrentBusiness.GSTRegistrationStatus;
          // filterObject.GSTRegistrationStatus = 1;
        }

        if(this.reportId == 108){
          filterObject.transactionListId = [10001];
          filterObject.formTransactionListId = [10002, 10003];
        }

        if(this.reportId == 417){
          filterObject.transactionListId = [20001];
          filterObject.formTransactionListId = [20002, 20003];
        }

        if((this.reportId == 601 || this.reportId == 901) && openingFY == selectedStartDateFY){
          filterObject.openingFYSelected = true;
        }

        if(this.$route.params.reportId == 301 && filterObject.partyId && filterObject.partyId.indexOf('SelectedItems') != -1){
          let parties = JSON.parse(filterObject.partyId);
          // let selectedParties = JSON.parse();
          filterObject.partyIds = [];
          for(let i=0; i<parties.SelectedItems.length; i++){
            filterObject.partyIds.push(parties.SelectedItems[i].id);
          }
          filterObject.partyId = null;
        }

        this.getReportData('Report', itemId, filterObject, this.loadingStatusObj,{

            onSuccess: function(response){
                console.log(response);

                let reportData = JSON.parse(response);

                self.loading = false;

                // assigning static party Cash A/c in case of Daybook-202 and Purchase Tax Summary-403 when listId 20005
                // assigning static party Journal in case of Daybook-202 when listId 30003
                // if(self.reportId == 101 || self.reportId == 202 || self.reportId == 403){
                  for(let i in reportData.data.detailRows){
                    if(self.reportId == 101 || self.reportId == 202 || self.reportId == 403 || self.reportId == 419){
                      if(!reportData.data.detailRows[i].cols.party){
                        if(reportData.data.detailRows[i].transactionListId == 20005){
                          reportData.data.detailRows[i].cols.party = "Cash A/c";
                        }
                        if(reportData.data.detailRows[i].transactionListId == 30003){
                          reportData.data.detailRows[i].cols.party = "Journal";
                        }
                        if(reportData.data.detailRows[i].transactionListId == 40004){
                          reportData.data.detailRows[i].cols.party = "Stock";
                        }
                      }
                    }
                    else if(self.reportId == 201){
                      if(reportData.data.detailRows[i].cols['creditDebitType'] == 'To Receive'){
                        reportData.data.detailRows[i].cols['creditDebitType'] = self.$root.fn_getDebitLabel();
                      }
                      else if(reportData.data.detailRows[i].cols['creditDebitType'] == 'To Pay'){
                        reportData.data.detailRows[i].cols['creditDebitType'] = self.$root.fn_getCreditLabel();
                      }

                      if(self.$root.TransactionSettings.ledgerCreditDebitLabelType == 2){
                        for(let key in dataConfig.headerRow){
                          if(key=='debit'){
                            dataConfig.headerRow[key] = self.$root.fn_getDebitLabel();
                          }
                          else if(key=='credit'){
                            dataConfig.headerRow[key] = self.$root.fn_getCreditLabel();
                          }
                        }

                        for(let i=0; i<dataConfig.headerRowTableHeaders.length; i++){
                          if(dataConfig.headerRowTableHeaders[i].headerName == 'To Receive'){
                            dataConfig.headerRowTableHeaders[i].headerName = self.$root.fn_getDebitLabel();
                          }
                          else if(dataConfig.headerRowTableHeaders[i].headerName == 'To Pay'){
                            dataConfig.headerRowTableHeaders[i].headerName = self.$root.fn_getCreditLabel();
                          }
                        }

                        if(reportData.data.footerRow['creditDebitType'] == 'To Receive'){
                          reportData.data.footerRow['creditDebitType'] = self.$root.fn_getDebitLabel();
                        }
                        else if(reportData.data.footerRow['creditDebitType'] == 'To Pay'){
                          reportData.data.footerRow['creditDebitType'] = self.$root.fn_getCreditLabel();
                        }
                      }
                    }

                    else if((self.reportId == 102 || self.reportId == 103) && self.$root.TransactionSettings.showSecondaryUnit && reportData.data.detailRows[i].cols['secondaryUnitName']){
                      reportData.data.detailRows[i].cols['productName'] = reportData.data.detailRows[i].cols['productName'] + ' (' + reportData.data.detailRows[i].cols['secondaryUnitPackQuantity'] + ' ' +reportData.data.detailRows[i].cols['secondaryUnitName'] + ')';
                    }

                    if(self.$root.TransactionSettings.showSecondaryUnit && self.$root.appVersion >= 253){
                      self.fn_processSecondaryUnitData(reportData.data.detailRows[i], reportData.data.footerRow, i);
                    }
                    else{
                      self.fn_removeSecondaryUnitData(reportData.data.detailRows[i]);
                    }
                    
                  }
                // }


                if(!self.$root.TransactionSettings.mrpWiseStock && (self.reportId == 101 || self.reportId == 102)){
                  self.fn_removeMrpColumn(reportData.data);
                }
                else{
                  self.$root.dataObj.reportData = reportData.data;

                   // removing header rows
                  self.fn_removeHeaderRows();

                  self.$root.dataObj.reportData.headerRow = dataConfig.headerRowTableHeaders;

                  if(self.reportId == 803){
                    self.fn_generateDataForGSTR3B(reportData);
                  }

                  if(self.reportId==303 || self.reportId==403 || self.reportId==312 || self.reportId==419){
                    self.fn_calculateFooterValues();
                  }
                  // if(self.$root.dataObj.reportData.detailRows && self.$root.dataObj.tableView){
                  //   self.fn_generateTable();
                  // }
                  // else{
                  //   self.hideLoading();
                  // }
                }

                if(self.$root.dataObj.tableView){
                  setTimeout(function(){
                    self.$refs['ref_reportTemplateContainer'].$refs['ref_generalReport'].fn_tableHeight();
                  },100);  
                }

                if(self.reportId == 205){
                  self.fn_processLedgerDetailReport();
                }

                // if(self.reportId == 310){
                //   self.fn_processSaleRegisterDetailReport();
                // }

                if(self.reportId == 310 || self.reportId == 311 || self.reportId == 312 || self.reportId == 418 || self.reportId == 419 || self.reportId == 420){
                  // self.fn_processSaleRegisterDetailReport();
                  self.fn_processDetailReport();
                }

                if(self.reportId == 104 && self.$root.dataObj.reportData.detailRows && self.$root.dataObj.reportData.detailRows.length){
                  self.$root.dataObj.reportData.detailRows.sort((a, b) => a.cols.profitLossAmount - b.cols.profitLossAmount);
                }

            }, 
            onError: function(error){
                console.log(error);
                // self.hideLoading();
                self.loading = false;
            }

        });
    },

    fn_processLedgerDetailReport: function(){
      let rows = this.$root.dataObj.reportData.detailRows;
      let hasHsn = false;
      let hasDiscount = false;
      let hasCgst = false;
      let hasSgst = false;
      let hasUtgst = false;
      let hasIgst = false;
      let hasCess = false;
      let hasCessPercentage = false;
      let hasCessOnQtyPercentage = false;
      let hasGstPercentage = false;

      for(let i=0; i<rows.length; i++){
        if(rows[i].cols.itemDetailRows){

          
          let itemDetailRows = rows[i].cols.itemDetailRows;
          
          // let hasHsn = false;
          // let hasDiscount = false;
          // let hasCgst = false;
          // let hasSgst = false;
          // let hasUtgst = false;
          // let hasIgst = false;
          // let hasCess = false;

          for(let j=0; j<itemDetailRows.length; j++){
            itemDetailRows[j].srNo = j + 1;

            if(itemDetailRows[j].hsnCode)
              hasHsn = true;
            if(itemDetailRows[j].discount)
              hasDiscount = true;
            if(itemDetailRows[j].cgst)
              hasCgst = true;
            if(itemDetailRows[j].sgst)
              hasSgst = true;
            if(itemDetailRows[j].utgst)
              hasUtgst = true;
            if(itemDetailRows[j].igst)
              hasIgst = true;
            if(itemDetailRows[j].cess)
              hasCess = true;
            if(itemDetailRows[j].cessPercentage)
              hasCessPercentage = true;
            if(itemDetailRows[j].cessOnQtyPercentage)
              hasCessOnQtyPercentage = true;
            if(itemDetailRows[j].gstPercentage)
              hasGstPercentage = true;
          }

          let subHeaders = {
            'srNo':'#',
            'productName':"Description",
            "qty":"Qty",
            "unit":"Unit",
            "rate":"Rate/Unit",
            "taxableValue":"Taxable Value",
            "total":"Total"
          }

          if(hasHsn)
            subHeaders.hsnCode = "HSN/SAC";
          if(hasDiscount)
            subHeaders.discount = "Discount";
          if(hasCgst)
            subHeaders.cgst = "CGST";
          if(hasSgst)
            subHeaders.sgst = "SGST";
          if(hasUtgst)
            subHeaders.utgst = "UTGST";
          if(hasIgst)
            subHeaders.igst = "IGST";
          if(hasCess)
            subHeaders.cess = "CESS";
          if(hasCessPercentage)
            subHeaders.cessPercentage = "CESS Percentage";
          if(hasCessOnQtyPercentage)
            subHeaders.cessOnQtyPercentage = "CESS On Qty Percentage";
          if(hasGstPercentage)
            subHeaders.gstPercentage = "GST Percentage";

          rows[i].subHeaders = subHeaders;

        }
      }
    },

    // fn_processSaleRegisterDetailReport: function(){
    fn_processDetailReport: function(){
      let rows = this.$root.dataObj.reportData.detailRows;

      let hasHsn = false;
      let hasDiscount = false;
      let hasCgst = false;
      let hasSgst = false;
      let hasUtgst = false;
      let hasIgst = false;
      let hasCess = false;
      let hasCessPercentage = false;
      let hasCessOnQtyPercentage = false;
      let hasGstPercentage = false;

      for(let i=0; i<rows.length; i++){
        if(rows[i].cols.itemDetailRows){
          
          let itemDetailRows = rows[i].cols.itemDetailRows;

          for(let j=0; j<itemDetailRows.length; j++){
            itemDetailRows[j].srNo = j + 1;

            if(itemDetailRows[j].hsnCode)
              hasHsn = true;
            if(itemDetailRows[j].discount)
              hasDiscount = true;
            if(itemDetailRows[j].cgst)
              hasCgst = true;
            if(itemDetailRows[j].sgst)
              hasSgst = true;
            if(itemDetailRows[j].utgst)
              hasUtgst = true;
            if(itemDetailRows[j].igst)
              hasIgst = true;
            if(itemDetailRows[j].cess)
              hasCess = true;
            if(itemDetailRows[j].cessPercentage)
              hasCessPercentage = true;
            if(itemDetailRows[j].cessOnQtyPercentage)
              hasCessOnQtyPercentage = true;
            if(itemDetailRows[j].gstPercentage)
              hasGstPercentage = true;
          }

          let subHeaders = {
            'srNo':'#',
            'productName':"Description",
            "qty":"Qty",
            "unit":"Unit",
            "rate":"Rate/Unit",
            "taxableValue":"Taxable Value",
            "total":"Total"
          }

          if(hasHsn)
            subHeaders.hsnCode = "HSN/SAC";
          if(hasDiscount)
            subHeaders.discount = "Discount";
          if(hasCgst)
            subHeaders.cgst = "CGST";
          if(hasSgst)
            subHeaders.sgst = "SGST";
          if(hasUtgst)
            subHeaders.utgst = "UTGST";
          if(hasIgst)
            subHeaders.igst = "IGST";
          if(hasCess)
            subHeaders.cess = "CESS";
          if(hasCessPercentage)
            subHeaders.cessPercentage = "CESS Percentage";
          if(hasCessOnQtyPercentage)
            subHeaders.cessOnQtyPercentage = "CESS Percentage";
          if(hasGstPercentage)
            subHeaders.gstPercentage = "GST Percentage";

          rows[i].subHeaders = subHeaders;

        }
      }
    },

    fn_generateDataForGSTR3B: function(reportData){
      let gstrData = {};
      gstrData.categories = [];

      for(let i in reportData.data.detailRows){

        if(reportData.data.detailRows[i].section == "3.1" && reportData.data.detailRows[i].mainRow){

          let sectionObj = {};
          sectionObj.subReportId = 'GSTR3B3_1';
          sectionObj.title = reportData.data.detailRows[i].cols.natureOfSupplies;
          sectionObj.section = reportData.data.detailRows[i].section;
          sectionObj.subreportData = {};
          sectionObj.subreportData.data = {};
          sectionObj.subreportData.data.detailRows = [];

          if(reportData.data.detailRows[i].mainRow){
            sectionObj.items = [
              {"title":"Integrated Tax", "value":reportData.data.detailRows[i].cols.igst},
              {"title":"Central Tax", "value":reportData.data.detailRows[i].cols.cgst},
              {"title":"State/UT Tax", "value":reportData.data.detailRows[i].cols.sgst},
              {"title":"Cess", "value":reportData.data.detailRows[i].cols.cess},
            ];  
          }
          else{
            sectionObj.subreportData.data.detailRows.push(reportData.data.detailRows[i]);
          }
          

          gstrData.categories.push(sectionObj);
        }

        if(reportData.data.detailRows[i].section == "3.2" && reportData.data.detailRows[i].mainRow){

          let sectionObj = {}
          sectionObj.subReportId = "GSTR3B3_2";
          sectionObj.title = reportData.data.detailRows[i].cols.natureOfSupplies;
          sectionObj.section = reportData.data.detailRows[i].section;
          sectionObj.subreportData = {};
          sectionObj.subreportData.data = {};
          sectionObj.subreportData.data.detailRows = [];

          if(reportData.data.detailRows[i].mainRow){
            sectionObj.items = [
              {"title":"Taxable Value", "value":reportData.data.detailRows[i].cols.taxableValue},
              {"title":"Integrated Tax", "value":reportData.data.detailRows[i].cols.igst}
            ];
          }
          else{
            sectionObj.subreportData.data.detailRows.push(reportData.data.detailRows[i]);
          }

          gstrData.categories.push(sectionObj);
        }

        if(reportData.data.detailRows[i].section == "4" && reportData.data.detailRows[i].mainRow){
          let sectionObj = {}
          sectionObj.subReportId = "GSTR3B4";
          sectionObj.title = reportData.data.detailRows[i].cols.natureOfSupplies;
          sectionObj.section = reportData.data.detailRows[i].section;
          sectionObj.subreportData = {};
          sectionObj.subreportData.data = {};
          sectionObj.subreportData.data.detailRows = [];

          if(reportData.data.detailRows[i].mainRow){
            sectionObj.items = [
              {"title":"Integrated Tax", "value":reportData.data.detailRows[i].cols.igst},
              {"title":"Central Tax", "value":reportData.data.detailRows[i].cols.cgst},
              {"title":"State/UT Tax", "value":reportData.data.detailRows[i].cols.sgst},
              {"title":"Cess", "value":reportData.data.detailRows[i].cols.cess},
            ];
          }
          else{
            sectionObj.subreportData.data.detailRows.push(reportData.data.detailRows[i]);
          }

          gstrData.categories.push(sectionObj);
        }

        if(reportData.data.detailRows[i].section == "5" && reportData.data.detailRows[i].mainRow){

          let sectionObj = {}
          sectionObj.subReportId = "GSTR3B5";
          sectionObj.title = reportData.data.detailRows[i].cols.natureOfSupplies;
          sectionObj.section = reportData.data.detailRows[i].section;
          sectionObj.subreportData = {};
          sectionObj.subreportData.data = {};
          sectionObj.subreportData.data.detailRows = [];

          if(reportData.data.detailRows[i].mainRow){
            sectionObj.items = [
              {"title":"Inter-State Supplies", "value":reportData.data.detailRows[i].cols.interStateAmount},
              {"title":"Intra-State Supplies", "value":reportData.data.detailRows[i].cols.intraStateAmount}
            ];
          }
          else{
            sectionObj.subreportData.data.detailRows.push(reportData.data.detailRows[i]);
          }

          gstrData.categories.push(sectionObj);
        }

        if(reportData.data.detailRows[i].section == "5.1" && reportData.data.detailRows[i].mainRow){
          let sectionObj = {}
          sectionObj.subReportId = "GSTR3B5_1";
          sectionObj.title = reportData.data.detailRows[i].cols.natureOfSupplies;
          sectionObj.section = reportData.data.detailRows[i].section;
          sectionObj.subreportData = {};
          sectionObj.subreportData.data = {};
          sectionObj.subreportData.data.detailRows = [];

          if(reportData.data.detailRows[i].mainRow){
            sectionObj.items = [
              {"title":"Integrated Tax", "value":reportData.data.detailRows[i].cols.igst},
              {"title":"Central Tax", "value":reportData.data.detailRows[i].cols.cgst},
              {"title":"State/UT Tax", "value":reportData.data.detailRows[i].cols.sgst},
              {"title":"Cess", "value":reportData.data.detailRows[i].cols.cess},
            ];
          }
          else{
            sectionObj.subreportData.data.detailRows.push(reportData.data.detailRows[i]);
          }

          gstrData.categories.push(sectionObj);
        }
        
      }

      this.$root.dataObj.reportData.gstr3BData = JSON.parse(JSON.stringify(gstrData));
      console.log(JSON.stringify(gstrData));
    },

    fn_removeMrpColumn: function(reportData){

      let removeMrpColumn = false;

      // for(let col in dataConfig.headerRow){
      //   if(dataConfig.headerRow[col] == 'MRP'){
      //     columnName = col;
      //     reportData.footerRow ? delete reportData.footerRow[col] : '';
      //     delete dataConfig.headerRow[col];
      //     break;
      //   }
      // }
      for(let i=0; i<dataConfig.headerRowTableHeaders.length; i++){
        if(dataConfig.headerRowTableHeaders[i].headerName == 'MRP'){
          // columnName = dataConfig.headerRowTableHeaders[i].headerName;
          removeMrpColumn = true;
          // reportData.footerRow ? delete reportData.footerRow[columnName] : '';
          reportData.footerRow ? delete reportData.footerRow["mrp"] : '';
          
          dataConfig.headerRow ? delete dataConfig.headerRow["mrp"] : '';
          dataConfig.headerRowTableHeaders.splice(i, 1);
          // delete dataConfig.headerRowTableHeaders[i];
          break;
        }
      }

      if(removeMrpColumn){
        for(let row=0; row<reportData.detailRows.length; row++){
          // delete reportData.detailRows[row].cols[columnName];
          delete reportData.detailRows[row].cols["mrp"];
        }

        let colIndex = this.$root.dataObj.columns.findIndex(col=>{
          // return col == columnName;
          return col == "mrp";
        });

        colIndex!=-1 ? this.$root.dataObj.columns.splice(colIndex, 1) : '';
      }

      this.$root.dataObj.reportData = reportData;
      // this.$root.dataObj.reportData.headerRow = dataConfig.headerRow;
      this.$root.dataObj.reportData.headerRow = dataConfig.headerRowTableHeaders;

      // if(this.$root.dataObj.reportData.detailRows && this.$root.dataObj.tableView){
      //   this.fn_generateTable();
      // }
      // else{
      //   this.hideLoading();
      // }
    },

    fn_calculateFooterValues: function(){
      let footerRow = {};
      footerRow.transactionDate = "Total";
      footerRow.party = null;
      footerRow.mergeTransactionNumber = null;
      footerRow.transactionListId = null;
      footerRow.gstNumber = null;
      footerRow.grossAmount = 0;
      footerRow.discount = 0;
      footerRow.otherCharges = 0;
      footerRow.taxableValue = 0;
      footerRow.cgst = 0;
      footerRow.stgst = 0;
      footerRow.igst = 0;
      footerRow.cess = 0;
      footerRow.additionalValue = 0;
      footerRow.roundedOff = 0;
      footerRow.roundedAmount = 0;
      footerRow.totalTax = this.$root.dataObj.reportData.footerRow.tax;
      let detailRows = this.$root.dataObj.reportData.detailRows;
      for(let i=0; i<detailRows.length; i++){
        for(let col in detailRows[i].cols){
          if(col=='grossAmount'){
            if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
              detailRows[i].cols[col] = -detailRows[i].cols[col];
            }
            footerRow.grossAmount += detailRows[i].cols[col];
          }
          else if(col=='discount'){
            if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
              detailRows[i].cols[col] = -detailRows[i].cols[col];
            }
            footerRow.discount += detailRows[i].cols[col];
          }
          else if(col=='otherCharges'){
            if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
              detailRows[i].cols[col] = -detailRows[i].cols[col];
            }
            footerRow.otherCharges += detailRows[i].cols[col];
          }
          else if(col=='taxableValue'){
            if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
              detailRows[i].cols[col] = -detailRows[i].cols[col];
            }
            footerRow.taxableValue += detailRows[i].cols[col];
          }
          else if(col=='cgst'){
            if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
              detailRows[i].cols[col] = -detailRows[i].cols[col];
            }
            footerRow.cgst += detailRows[i].cols[col];
          }
          else if(col=='stgst'){
            if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
              detailRows[i].cols[col] = -detailRows[i].cols[col];
            }
            footerRow.stgst += detailRows[i].cols[col];
          }
          else if(col=='igst'){
            if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
              detailRows[i].cols[col] = -detailRows[i].cols[col];
            }
            footerRow.igst += detailRows[i].cols[col];
          }
          else if(col=='cess'){
            if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
              detailRows[i].cols[col] = -detailRows[i].cols[col];
            }
            footerRow.cess += detailRows[i].cols[col];
          }
          else if(col=='additionalValue'){
            if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
              detailRows[i].cols[col] = -detailRows[i].cols[col];
            }
            footerRow.additionalValue += detailRows[i].cols[col];
          }
          else if(col=='roundedOff'){
            // if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
            //   // detailRows[i].cols[col] = -detailRows[i].cols[col];
            //   footerRow.roundedOff += detailRows[i].cols[col];
            // }
            footerRow.roundedOff += detailRows[i].cols[col];
          }
          else if(col=='roundedAmount'){
            if(detailRows[i].transactionListId==10004 || detailRows[i].transactionListId==20004){
              detailRows[i].cols[col] = -detailRows[i].cols[col];
            }
            footerRow.roundedAmount += detailRows[i].cols[col];
          }
        }

        footerRow.grossAmount = this.roundUpto2Decimals(footerRow.grossAmount);
        footerRow.discount = this.roundUpto2Decimals(footerRow.discount);
        footerRow.otherCharges = this.roundUpto2Decimals(footerRow.otherCharges);
        footerRow.taxableValue = this.roundUpto2Decimals(footerRow.taxableValue);
        footerRow.cgst = this.roundUpto2Decimals(footerRow.cgst);
        footerRow.stgst = this.roundUpto2Decimals(footerRow.stgst);
        footerRow.igst = this.roundUpto2Decimals(footerRow.igst);
        footerRow.cess = this.roundUpto2Decimals(footerRow.cess);
        footerRow.additionalValue = this.roundUpto2Decimals(footerRow.additionalValue);
        footerRow.roundedOff = this.roundUpto2Decimals(footerRow.roundedOff);
        footerRow.roundedAmount = this.roundUpto2Decimals(footerRow.roundedAmount);
        footerRow.totalTax = this.roundUpto2Decimals(footerRow.totalTax);

        this.$root.dataObj.reportData.footerRow = footerRow;
        console.log(JSON.stringify(this.$root.dataObj.reportData));
      }
    },

    // fn_getReportItemDetails: function(itemId){
      fn_getReportItemDetails: function(event, transactionListId, transactionId){
        if(transactionListId == 40003){
          return;
        }

        let filterObject = {};
        // filterObject.reportId = this.$root.dataObj.detailReportId;
        filterObject.reportId = 2011;

        this.detailReportObj = JSON.parse(JSON.stringify(require('../data_config/'+this.fn_getReportDataFileName()).data.fn_getData(2011)));

        let self = this;
        this.getReportData('Report', transactionId, filterObject, null,{

            onSuccess: function(response){
                console.log(response);

                let reportData = JSON.parse(response);
                self.$set(self.detailReportObj, 'detailRows', reportData.data.detailRows);
                self.$set(self.detailReportObj, 'footerRow', reportData.data.footerRow);
                self.detailReportObj.transactionId = transactionId;
                self.detailReportObj.transactionListId = transactionListId;
                self.$forceUpdate();
                // self.bottomSheet = true;
                self.fn_openTransactionDetails(event);
            }, 
            onError: function(error){
                console.log(error);
            }

        });
    },

    fn_openTransactionDetails: function (e) {
      e.preventDefault();
      this.transactionDetails = false;
      this.x = e.clientX;
      this.y = e.clientY;
      this.$nextTick(() => {
        this.transactionDetails = true;
      })
    },

    fn_processDataForExcel: function(){
        this.exportExcel = true;

        let startDate = null;
        let endDate = null;

        if(this.$root.dataObj.startDate){
            startDate = this.$moment(this.$root.dataObj.startDate).format('DD-MMM-YYYY');  
        }
        
        if(this.$root.dataObj.endDate){
            endDate = this.$moment(this.$root.dataObj.endDate).format('DD-MMM-YYYY');
        }

        let subReportData = null

        let isSubReport = false;
        if(this.$route.query.subreport){
            isSubReport = true;
            startDate = this.$moment(this.$route.query.startDate).format('DD-MMM-YYYY'); 
            endDate = this.$moment(this.$route.query.endDate).format('DD-MMM-YYYY'); 
            if(this.$route.query.subreport == 1){
                subReportData = this.subReportData;  
            }
            else if(this.$route.query.subreport == 2){
                subReportData = this.subReportData2;
            }
        }

        let dataObj = {};

        if(this.subReportData && this.$route.query.subreport){
            dataObj = {"reportDataObject":{}}
            dataObj.reportDataObject.reportData = JSON.parse(JSON.stringify(subReportData.data));
            dataObj.reportDataObject.reportData.headerRow = subReportData.headerRow;
            dataObj.reportDataObject.reportData.internalHeaderRow = subReportData.internalHeaderRow;
        }
        else{
            dataObj.reportDataObject = JSON.parse(JSON.stringify(this.$root.dataObj)); 

            if(this.reportId == 803){
                dataObj.reportDataObject.reportData.detailRows = dataObj.reportDataObject.reportData.detailRows.filter(item=>{
                    return item.mainRow;
                });
                console.log(JSON.stringify(dataObj.reportDataObject));
            }
        }

        // deletion as date oject creating problem while posting data to webworker
        delete dataObj.reportDataObject.filters;
        delete dataObj.reportDataObject.startDate;
        delete dataObj.reportDataObject.endDate;

        dataObj.otherData = {};
        dataObj.reportDataObject.reportData.headerRow = isSubReport ? subReportData.headerRow : dataConfig.headerRow;
        dataObj.otherData.headerRow1 = this.$root.CurrentBusiness.BusinessName;
        dataObj.otherData.headerRow2 = isSubReport ? subReportData.reportTitle : this.$root.dataObj.reportTitle;

        let sdate = startDate ? startDate + ' To ' : '';
        dataObj.otherData.headerRow3 = this.$root.dataObj.periodLabel + ': ' + sdate + endDate;

        dataObj.otherData.headerRow4 = this.$root.dataObj.itemLabel ? this.$root.dataObj.itemLabel+ ': ' + this.$root.dataObj.itemName : null;

        if(this.$root.reportFilterObj && Object.keys(this.$root.reportFilterObj).length){
            dataObj.otherData.headerRow5 = '';
            for(let key in this.$root.reportFilterObj){
                let index = 0;
                dataObj.otherData.headerRow5 += this.$root.reportFilterObj[key].name + ': ' + this.$root.reportFilterObj[key].value + (index != Object.keys(this.$root.reportFilterObj).length-1 ? ', ' : '');
                index++
            }
        }

      console.log(JSON.stringify(dataObj));

      prepareExcel(dataObj, this);

    },

    fn_getGSTPortalData: function(){
        this.exportExcel = true;

        let filterObject = {};
        filterObject.startDate = this.$moment(this.$root.dataObj.startDate).startOf('day');//new Date(this.$root.dataObj.startDate);
        filterObject.endDate = this.$moment(this.$root.dataObj.endDate).endOf('day');

        filterObject.startDate = this.$root.fn_getLocalDateFormat(filterObject.startDate);
        filterObject.endDate = this.$root.fn_getLocalDateFormat(filterObject.endDate);

        let dataSheets = [];

        let self = this;
        this.getFilterData('GSTPortalData', this.$root.CurrentBusiness.StateID, filterObject, null,{
            onSuccess: function(response){
                console.log(response);
                let data = JSON.parse(response);
                for(let key in dataConfig.gstPortalReportObj){
                    let dataObj = {};
                    dataObj.otherData = {};
                    dataObj.reportDataObject = {};
                    dataObj.reportDataObject.reportData = {};
                    dataObj.reportDataObject.reportData.detailRows = data[key] ?  data[key] : [];
                    dataObj.reportDataObject.reportData.headerRow = dataConfig.gstPortalReportObj[key].headerRow;
                    dataObj.reportDataObject.headerRow1 = dataConfig.gstPortalReportObj[key].title;
                    dataObj.reportDataObject.headerRow2 = null;
                    dataObj.reportDataObject.headerRow3 = null;
                    dataObj.otherData.sheetName = key;
                    dataSheets.push(dataObj);
                }

                console.log(JSON.stringify(dataSheets));

                prepareExcelForGSTPortal(dataSheets, self);
            },
            onError: function(error){
                console.log(error);
            }
        });
    },

    // fn_share: function(){
    //     if (navigator.share) {
    //         navigator.share({
    //             title: 'WebShare API Demo',
    //             url: 'https://google.com'
    //         }).then(() => {
    //             console.log('Thanks for sharing!');
    //         })
    //         .catch(console.error);
    //     } else {
    //         // shareDialog.classList.add('is-open');
    //     }
    // },

    // fn_exportTest: function(){
    //     var doc = new jsPDF();
    //     doc.setFont('TiroDevanagariHindi-Regular', 'normal');
    //     doc.text(10,10,'jfkdfjf ₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹₹');
    //     doc.save("testfile");
    // },

    fn_export: function(){

        if(this.subReportData && this.$route.query.subreport){
            this.fn_exportSubReport();
            return;
        }

      // var doc = new jsPDF({
      //   orientation: 'p',
      //   unit: 'px',
      //   format: 'a4',
      //   putOnlyUsedFonts:true,
      // });

      // doc.html(htmlContent, {
      //   callback: function (doc) {
      //     doc.save();
      //   }
      // });

      // var doc = new jsPDF();

      // doc.text("Hello",10,10)
      // doc.save();

      // var doc = new jsPDF('p', 'pt', 'a4');

      let pageOrientation = 'portrait';
      let minCellWidth = 20
      let logoPos = 175

      if(this.$root.dataObj.reportData.headerRow.length > 8 || (this.$route.params.reportId==801 || this.$route.params.reportId==802 || this.$route.params.reportId==803 || this.$route.params.reportId==804 || this.$route.params.reportId==205 || this.$route.params.reportId==308 || this.$route.params.reportId==310 ||this.$route.params.reportId==311 || this.$route.params.reportId==418 || this.$route.params.reportId==420)){
        pageOrientation = 'landscape';
        minCellWidth = 16
        logoPos = 262
      }

      const doc = new jsPDF({orientation: pageOrientation});

      doc.setFont('Hind-Regular', 'normal');

      doc.setFontSize(11);

      // let finalY = doc.lastAutoTable.finalY
      doc.text(this.$root.CurrentBusiness.BusinessName, 4.5, 8);
      doc.text("Report: " + this.$root.dataObj.reportTitle, 4.5, 14);

      let mtop = 14;

      if(this.$root.dataObj.itemLabel){
        mtop = mtop + 6;
        doc.text(this.$root.dataObj.itemLabel + ": " + this.$root.dataObj.itemName, 4.5, mtop);
      }

      if(this.$root.dataObj.periodLabel == 'Period'){
        mtop = mtop + 6;
        doc.text("Period: " + this.$moment(this.$root.dataObj.startDate).format('DD-MMM-YYYY') + " To " + this.$moment(this.$root.dataObj.endDate).format('DD-MMM-YYYY'), 4.5, mtop);
      }
      else{
        mtop = mtop + 6;
        doc.text("As On: " + this.$moment(this.$root.dataObj.endDate).format('DD-MMM-YYYY'), 4.5, mtop);
      }

      let logoImage = require('../../../assets/logo_image.png');
      doc.addImage(logoImage, 'png', logoPos, mtop - 5, 30, 6);
      // hack to apply link on powered by logo
      doc.textWithLink('                                           ', logoPos+5, mtop, { url: 'https://bizopsapp.com' });


        // var font = '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';
        // var callAddFont = function () {
        //     this.addFileToVFS('rupeefont-normal.ttf', font);
        //     this.addFont('rupeefont-normal.ttf', 'rupeefont', 'normal');
        // };
        // jsPDF.API.events.push(['addFonts', callAddFont]);

        console.log(doc.getFontList());
        
        // doc.setFont('ascii');

        // let self = this;
        // let contentHeight = 0;

      // doc.autoTable({ html: '#my-table-print' });
      if(this.$route.params.reportId == 205 || this.$route.params.reportId == 310 || this.$route.params.reportId == 311 || this.$route.params.reportId == 312 || this.$route.params.reportId == 418 || this.$route.params.reportId == 419 || this.$route.params.reportId == 420){
        // exporting detail report thru processing data as columns length of parent and child(internal) table is different
        // jspdf doesn't handle irregular columns width
        this.fn_exportDetailsReport(mtop, doc);
      }
      else{
        doc.autoTable({
            startY:mtop + 4,
            margin:5,

            html: '#my-table-print',
            styles: {
                fontSize: this.$root.dataObj.reportData.headerRow.length  > 8 ? 6 : 8, 
                minCellWidth:minCellWidth, 
                halign: 'justify', 
                tableWidth: 'wrap',
                font:'Hind-Regular',
                fontStyle: 'normal',
                textColor:[0,0,0],
            },
            headStyles: {
                fillColor:[240,240,240],
                textColor:[0,0,0],
                fontStyle:'bold'
            },
            rowPageBreak: 'avoid',
            didParseCell:(data)=>{
              if(data?.cell?.raw?._prevClass?.indexOf('report-sub-item') != -1){
                 data.cell.styles.cellPadding = {top: 2,right: 2,bottom: 2,left: 10};
              }
              // if(data?.cell?.text?.length && !isNaN(Number(data?.cell?.text[0]))){
              if(data?.cell?.raw?._prevClass?.indexOf('right-align') != -1){
                 data.cell.styles.halign = 'right';
              }
            },
            didDrawCell: (data) => {
                if(data?.cell?.raw?._prevClass?.indexOf('has_rupee_symbol') != -1){
                    var base64Img = require('../../../assets/rupee_symbol.png');
                    doc.addImage(base64Img, 'png', data.cell.x + data.cell.contentWidth - 1.5, data.cell.y + 1.8, 3, 3);
                }

                

                // if(self.$root.dataObj.reportData.headerRow.length / (data.column.index + 1) == 1){
                //   contentHeight += data.row.height;
                // }
                

                // let logImage = require('../../../assets/logo_image.png');

                // if(data.row.index == self.$root.dataObj.reportData.detailRows.length && data.column.index == self.$root.dataObj.reportData.headerRow.length - 1){
                  // doc.addImage(logImage, 'png', 175, doc.autoTableEndPosY() + 50, 30, 6);
                  // doc.addImage(logImage, 'png', 175, (contentHeight/self.$root.dataObj.reportData.headerRow.length) + 32, 30, 6);
                  // let finalY = doc?.lastAutoTable?.finalY;
                  // alert(doc?.lastAutoTable?.finalY);
                  // doc.addImage(logImage, 'png', 175, contentHeight + 32, 30, 6);
                  // doc.addImage(logImage, 'png', 175, doc.autoTable.previous.finalY, 30, 6);
                // }
                

                // if (data.section === 'head' && data.column.index !== 0) {
                //     if(data.cell.raw._prevClass.indexOf('has_rupee_symbol') != -1){
                //         var base64Img = require('../../../assets/rupee_symbol.png');
                //         doc.addImage(base64Img, 'png', data.cell.x + data.cell.contentWidth - 1.5, data.cell.y + 1.8, 3, 3);
                //     }
                // }
            },
        });

        let fileName = this.$root.dataObj.reportTitle.replace(/ /g,'') + '-Report_' + this.$root.fn_getCurrentDateTimeString();

        doc.save(fileName);
      }
      


    //   doc.text("Hello", 50, 50)

      // let fileName = this.$root.dataObj.reportTitle.replace(/ /g,'') + '-Report_' + this.$root.fn_getCurrentDateTimeString();

      // doc.save(fileName);

    },

    // exporting detail report thru processing data as columns length of parent and child(internal) table is different
    // jspdf doesn't handle irregular columns width
    fn_exportDetailsReport: function(mtop, doc){
      let rows = this.$root.dataObj.reportData.detailRows;
      let hasHsn = false;
      let hasDiscount = false;
      let hasCgst = false;
      let hasSgst = false;
      let hasUtgst = false;
      let hasIgst = false;
      let hasCess = false;
      let hasCessPercentage = false;
      let hasCessOnQtyPercentage = false;
      let hasGstPercentage = false;

      let reportConfig = JSON.parse(JSON.stringify(require('../data_config/'+this.fn_getReportDataFileName()).data.fn_getData(this.$route.params.reportId)));
      let headers = [];
      for(let i=0; i<reportConfig.headerRowTableHeaders.length; i++){
        headers.push(reportConfig.headerRowTableHeaders[i].headerName);
      }

      let footers = [];
      if(this.$root.dataObj.reportData.footerRow){
        for(let j=0; j<reportConfig.columns.length; j++){
          footers.push(this.$root.dataObj.reportData.footerRow[reportConfig.columns[j]]);
        }
      }

      let self = this;

      // const doc = new jsPDF({orientation: 'landscape'});
      let parentRows = [];
      let detailSubHeaders = null;
      rows.forEach(row=>{

        if(row.cols.itemDetailRows){
          let itemDetailRows = row.cols.itemDetailRows;

          for(let j=0; j<itemDetailRows.length; j++){
            itemDetailRows[j].srNo = j + 1;

            if(itemDetailRows[j].hsnCode)
              hasHsn = true;
            if(itemDetailRows[j].discount)
              hasDiscount = true;
            if(itemDetailRows[j].cgst)
              hasCgst = true;
            if(itemDetailRows[j].sgst)
              hasSgst = true;
            if(itemDetailRows[j].utgst)
              hasUtgst = true;
            if(itemDetailRows[j].igst)
              hasIgst = true;
            if(itemDetailRows[j].cess)
              hasCess = true;
            if(itemDetailRows[j].cessPercentage)
              hasCessPercentage = true;
            if(itemDetailRows[j].cessOnQtyPercentage)
              hasCessOnQtyPercentage = true;
            if(itemDetailRows[j].gstPercentage)
              hasGstPercentage = true;
          }

          detailSubHeaders = {
            'srNo':'#',
            'productName':"Description",
            "qty":"Qty",
            "unit":"Unit",
            "rate":"Rate/Unit",
            "taxableValue":"Taxable Value",
            "total":"Total"
          }

          if(hasHsn)
            detailSubHeaders.hsnCode = "HSN/SAC";
          if(hasDiscount)
            detailSubHeaders.discount = "Discount";
          if(hasCgst)
            detailSubHeaders.cgst = "CGST";
          if(hasSgst)
            detailSubHeaders.sgst = "SGST";
          if(hasUtgst)
            detailSubHeaders.utgst = "UTGST";
          if(hasIgst)
            detailSubHeaders.igst = "IGST";
          if(hasCess)
            detailSubHeaders.cess = "CESS";
          if(hasCessPercentage)
            detailSubHeaders.cessPercentage = "CESS Percentage";
          if(hasCessOnQtyPercentage)
            detailSubHeaders.cessOnQtyPercentage = "CESS On Qty Percentage";
          if(hasGstPercentage)
            detailSubHeaders.gstPercentage = "GST Percentage";

        }

        parentRows = parentRows.concat(self.fn_getRowData(row, detailSubHeaders, footers));
      })

      parentRows.push(footers);

      if(detailSubHeaders && headers.length < Object.keys(detailSubHeaders).length){
        let extraLength = Object.keys(detailSubHeaders).length - headers.length;
        for(let l=0; l<extraLength; l++){
          headers.push('');
        }
      }

      // Parent Row
      doc.autoTable({
          
          head: [headers],

          body: parentRows,

          // startY: doc.lastAutoTable
          //     ? doc.lastAutoTable.finalY
          //     : 20,
          startY:mtop + 4,
          margin:5,
          styles: {
              fontSize: this.$root.dataObj.reportData.headerRow.length  > 8 ? 6 : 8, 
              minCellWidth:16, 
              halign: 'justify', 
              tableWidth: 'wrap',
              font:'Hind-Regular',
              fontStyle: 'normal',
              textColor:[0,0,0],
          },
          headStyles: {
              fillColor:[240,240,240],
              textColor:[0,0,0],
              fontStyle:'bold',
          },
          rowPageBreak: 'avoid',
      });

      let fileName = this.$root.dataObj.reportTitle.replace(/ /g,'') + '-Report_' + this.$root.fn_getCurrentDateTimeString();

      doc.save(fileName);
    },

    fn_getRowData(row, detailSubHeaders){
      let reportConfig = JSON.parse(JSON.stringify(require('../data_config/'+this.fn_getReportDataFileName()).data.fn_getData(this.$route.params.reportId)));
      let dataArr = [];
      let parentDataArr = [];
      // dataArr.push(row.cols[col]);
      reportConfig.columns.forEach(colHeader=>{
        let data = colHeader=='transactionDate' ? this.$moment(row.cols[colHeader]).format('DD-MMM-YYYY') : row.cols[colHeader];
        dataArr.push(data);
      });

      parentDataArr.push(dataArr);
      // reportConfig.columns.forEach(col=>{
      // Object.keys(row.cols).forEach(key=>{
        // console.log(key);
        if(row.cols.itemDetailRows && row.cols.itemDetailRows.length){

          // pushing header
          dataArr = [];
          dataArr.push(detailSubHeaders['srNo']);
          dataArr.push(detailSubHeaders['productName']);
          detailSubHeaders['hsnCode'] ? dataArr.push(detailSubHeaders['hsnCode']) : '';
          dataArr.push(detailSubHeaders['qty']);
          dataArr.push(detailSubHeaders['unit']);
          dataArr.push(detailSubHeaders['rate']);
          detailSubHeaders['discount'] ? dataArr.push(detailSubHeaders['discount']) : '';
          dataArr.push(detailSubHeaders['taxableValue']);
          detailSubHeaders['gstPercentage'] ? dataArr.push(detailSubHeaders['gstPercentage']) : '';
          detailSubHeaders['cgst'] ? dataArr.push(detailSubHeaders['cgst']) : '';
          detailSubHeaders['sgst'] ? dataArr.push(detailSubHeaders['sgst']) : '';
          detailSubHeaders['utgst'] ? dataArr.push(detailSubHeaders['utgst']) : '';
          detailSubHeaders['igst'] ? dataArr.push(detailSubHeaders['igst']) : '';
          detailSubHeaders['cessPercentage'] ? dataArr.push(detailSubHeaders['cessPercentage']) : '';
          detailSubHeaders['cessOnQtyPercentage'] ? dataArr.push(detailSubHeaders['cessOnQtyPercentage']) : '';
          detailSubHeaders['cess'] ? dataArr.push(detailSubHeaders['cess']) : '';
          dataArr.push(detailSubHeaders['total']);

          let headerColumns = [];
          Object.keys(detailSubHeaders).forEach((key)=>{
            // dataArr.push(detailSubHeaders[key]);
            headerColumns.push(key);
          });

          const filteredData = Object.fromEntries(
            Object.entries(row.cols.itemDetailRows[0]).filter(([key]) => headerColumns.includes(key))
          );

          if(parentDataArr[0].length < Object.keys(filteredData).length){
            let blankIterations = Object.keys(filteredData).length - parentDataArr[0].length;
            for(let k=0; k<blankIterations; k++){
              parentDataArr[0].push('');
              // footers.push('');
            }
          }

          parentDataArr.push(dataArr);

          // pushing data rows
          row.cols.itemDetailRows.forEach(item=>{

            // dataArr = [];
            for(let i=0; i<headerColumns.length; i++){
              // dataArr.push(item[headerColumns[i]]);
              dataArr = [];
              dataArr.push(item['srNo']);
              dataArr.push(item['productName']);
              item['hsnCode'] ? dataArr.push(item['hsnCode']) : detailSubHeaders['hsnCode'] ? dataArr.push('') : '';
              dataArr.push(item['qty']);
              dataArr.push(item['unit']);
              dataArr.push(item['rate']);
              item['discount'] ? dataArr.push(item['discount']) : detailSubHeaders['hsnCode'] ? dataArr.push('') : '';
              dataArr.push(item['taxableValue']);
              item['gstPercentage'] ? dataArr.push(item['gstPercentage']) : detailSubHeaders['gstPercentage'] ? dataArr.push('') : '';
              item['cgst'] ? dataArr.push(item['cgst']) : detailSubHeaders['cgst'] ? dataArr.push('') : '';
              item['sgst'] ? dataArr.push(item['sgst']) : detailSubHeaders['sgst'] ? dataArr.push('') : '';
              item['utgst'] ? dataArr.push(item['utgst']) : detailSubHeaders['utgst'] ? dataArr.push('') : '';
              item['igst'] ? dataArr.push(item['igst']) : detailSubHeaders['igst'] ? dataArr.push('') : '';
              item['cessPercentage'] ? dataArr.push(item['cessPercentage']) : detailSubHeaders['cessPercentage'] ? dataArr.push('') : '';
              item['cessOnQtyPercentage'] ? dataArr.push(item['cessOnQtyPercentage']) : detailSubHeaders['cessOnQtyPercentage'] ? dataArr.push('') : '';
              item['cess'] ? dataArr.push(item['cess']) : detailSubHeaders['cess'] ? dataArr.push('') : '';
              dataArr.push(item['total']);
            }
            parentDataArr.push(dataArr);
          })

          // pushing subtotal row
          if(row.cols.subTotal){
            // dataArr = [];
            // for(let i=0; i<headerColumns.length; i++){
            //  dataArr.push(row.cols.subTotal[headerColumns[i]]);

              dataArr = [];
              dataArr.push(row.cols.subTotal['srNo']);
              dataArr.push(row.cols.subTotal['productName']);
              row.cols.subTotal['hsnCode'] ? dataArr.push(row.cols.subTotal['hsnCode']) : '';
              dataArr.push(row.cols.subTotal['qty']);
              dataArr.push(row.cols.subTotal['unit']);
              dataArr.push(row.cols.subTotal['rate']);
              row.cols.subTotal['discount'] ? dataArr.push(row.cols.subTotal['discount']) : '';
              dataArr.push(row.cols.subTotal['taxableValue']);
              detailSubHeaders['gstPercentage'] ? dataArr.push(row.cols.subTotal['gstPercentage']) : '';
              detailSubHeaders['cgst'] ? dataArr.push(row.cols.subTotal['cgst']) : '';
              detailSubHeaders['sgst'] ? dataArr.push(row.cols.subTotal['sgst']) : '';
              detailSubHeaders['utgst'] ? dataArr.push(row.cols.subTotal['utgst']) : '';
              detailSubHeaders['igst'] ? dataArr.push(row.cols.subTotal['igst']) : '';
              detailSubHeaders['cessPercentage'] ? dataArr.push(row.cols.subTotal['cessPercentage']) : '';
              detailSubHeaders['cessOnQtyPercentage'] ? dataArr.push(row.cols.subTotal['cessOnQtyPercentage']) : '';
              detailSubHeaders['cess'] ? dataArr.push(row.cols.subTotal['cess']) : '';
              dataArr.push(row.cols.subTotal['total']);
            // }
            parentDataArr.push(dataArr);
          }

          // pushing bill addons row
          if(row.cols.billAddOns){
            // dataArr = [];
            // for(let i=0; i<headerColumns.length; i++){
              // dataArr.push(row.cols.billAddOns[headerColumns[i]]);
              dataArr = [];
              dataArr.push('');
              dataArr.push('');
              row.cols.billAddOns['hsnCode'] ? dataArr.push('') : '';
              dataArr.push('');
              dataArr.push('');
              dataArr.push('');
              row.cols.billAddOns['discount'] ? dataArr.push(row.cols.billAddOns['discount']) : '';
              dataArr.push('');
              dataArr.push('Bill Add Ons');
              detailSubHeaders['gstPercentage'] ? dataArr.push('') : '';
              detailSubHeaders['cgst'] ? dataArr.push('') : '';
              detailSubHeaders['sgst'] ? dataArr.push('') : '';
              detailSubHeaders['utgst'] ? dataArr.push('') : '';
              detailSubHeaders['igst'] ? dataArr.push('') : '';
              detailSubHeaders['cessPercentage'] ? dataArr.push('') : '';
              detailSubHeaders['cessOnQtyPercentage'] ? dataArr.push('') : '';
              detailSubHeaders['cess'] ? dataArr.push('') : '';
              dataArr.push(row.cols.billAddOns['total']);
              
            // }
            parentDataArr.push(dataArr);
          }
          
          // pushing tds row
          if(row.cols.tdsAddOns){
            // dataArr = [];
            // for(let i=0; i<headerColumns.length; i++){
              // dataArr.push(row.cols.tdsAddOns[headerColumns[i]]);
              
            // }

            dataArr = [];
            dataArr.push('');
            dataArr.push('');
            row.cols.tdsAddOns['hsnCode'] ? dataArr.push('') : '';
            dataArr.push('');
            dataArr.push('');
            dataArr.push('');
            row.cols.tdsAddOns['discount'] ? dataArr.push(row.cols.tdsAddOns['discount']) : '';
            dataArr.push('');
            dataArr.push('Tds Add Ons');
            detailSubHeaders['gstPercentage'] ? dataArr.push('') : '';
            detailSubHeaders['cgst'] ? dataArr.push('') : '';
            detailSubHeaders['sgst'] ? dataArr.push('') : '';
            detailSubHeaders['utgst'] ? dataArr.push('') : '';
            detailSubHeaders['igst'] ? dataArr.push('') : '';
            detailSubHeaders['cessPercentage'] ? dataArr.push('') : '';
            detailSubHeaders['cessOnQtyPercentage'] ? dataArr.push('') : '';
            detailSubHeaders['cess'] ? dataArr.push('') : '';
            dataArr.push(row.cols.tdsAddOns['total']);
            parentDataArr.push(dataArr);
          }

          // pushing total row
          if(row.cols.total){
            // dataArr = [];
            // for(let i=0; i<headerColumns.length; i++){
              // dataArr.push(row.cols.total[headerColumns[i]]);
            // }
            dataArr = [];
            dataArr.push('');
            dataArr.push('');
            row.cols.total['hsnCode'] ? dataArr.push('') : '';
            dataArr.push('');
            dataArr.push('');
            dataArr.push('');
            row.cols.total['discount'] ? dataArr.push(row.cols.total['discount']) : '';
            dataArr.push('');
            dataArr.push('Total');
            detailSubHeaders['gstPercentage'] ? dataArr.push('') : '';
            detailSubHeaders['cgst'] ? dataArr.push('') : '';
            detailSubHeaders['sgst'] ? dataArr.push('') : '';
            detailSubHeaders['utgst'] ? dataArr.push('') : '';
            detailSubHeaders['igst'] ? dataArr.push('') : '';
            detailSubHeaders['cessPercentage'] ? dataArr.push('') : '';
            detailSubHeaders['cessOnQtyPercentage'] ? dataArr.push('') : '';
            detailSubHeaders['cess'] ? dataArr.push('') : '';
            dataArr.push(row.cols.total['total']);
            parentDataArr.push(dataArr);
          }

          // // pushing footer
          // if(footers && footers.length){
          //   parentDataArr.push(footers);
          // }

        }
        // else{
        //   // dataArr.push(row.cols[col]);
        //   reportConfig.columns.forEach(colHeader=>{
        //     parentDataArr.push(row.cols[colHeader]);
        //   })
        // }
        
      // })
      // return dataArr;
      return parentDataArr;
    },

    // fn_exportSubReport: function(type){
    fn_exportSubReport: function(){

        // let data = null;

    //   data = type == "subreport" ? this.subReportData : this.subReportData2
        let data = this.$route.query.subreport == 1 ? this.subReportData : this.subReportData2;
      
        // const doc = new jsPDF({orientation: data.headerRowArr.length > 6 ? "landscape" : 'portrait'});
        const doc = new jsPDF({orientation: "landscape"});

        doc.setFontSize(11);

        doc.text(this.$root.CurrentBusiness.BusinessName, 4.5, 8);
        doc.text("Report: " + this.$route.query.reporttitle, 4.5, 14);
        doc.text("Period: " + this.$moment(this.$root.dataObj.startDate).format('DD-MMM-YYYY') + " To " + this.$moment(this.$root.dataObj.endDate).format('DD-MMM-YYYY'), 4.5, 20);

        let logoImage = require('../../../assets/logo_image.png');
        doc.addImage(logoImage, 'png', 262, 16, 30, 6);
        // hack to apply link on powered by logo
        doc.textWithLink('                                           ', 262+5, 20, { url: 'https://bizopsapp.com' });

        doc.autoTable({
            startY:24,
            margin:5,
            html: '.gstr-sub-table-print',
            // styles: {fontSize: data.headerRowArr.length > 6 ? 6 : 8, cellWidth: 'wrap', halign: 'justify', tableWidth: 'wrap'},
            styles: {fontSize: data.headerRowArr.length > 6 ? 6 : 8, cellWidth: 'wrap', halign: 'justify', tableWidth: 'wrap'},
            headStyles: {
                fillColor:[240,240,240],
                textColor:[0,0,0,0.87],
                fontStyle:'bold'
            },
            rowPageBreak: 'avoid',
            didDrawCell: (data) => {
                console.log(data);
                if(data.cell && data.cell.raw && data.cell.raw._prevClass && data.cell.raw._prevClass.indexOf('has_rupee_symbol') != -1){
                    var base64Img = require('../../../assets/rupee_symbol.png');

                    var dim = data.cell.height - data.cell.padding('vertical');
                    if(data.cell.raw._prevClass.indexOf('internal_header') != -1)
                        doc.addImage(base64Img, 'png', data.cell.x + data.cell.contentWidth, data.cell.y + 1.5, dim, dim);
                    else
                        doc.addImage(base64Img, 'png', data.cell.x + data.cell.contentWidth, data.cell.y + 1.8, dim, dim);
                }
            },
        });

        let fileName = data.reportTitle.replace(/[^a-zA-Z0-9]/g,'_');
        fileName = fileName.replace(/ /g,'') + '-Report_' + this.$root.fn_getCurrentDateTimeString();
        doc.save(fileName);
    },

    // fn_action: function(type, share){
    fn_action: function(contentId){

        let fileName = this.$root.dataObj.reportTitle.replace(/[^a-zA-Z0-9]/g,'_');
        document.title = fileName.replace(/ /g,'') + '-Report_' + this.$root.fn_getCurrentDateTimeString();

        // if(contentId == "printsubreport" || contentId == "printsubreport2"){
        if(this.subreportData){
            // document.getElementById("printable-section").style.display = "none";
            // setTimeout(() => {
            //     document.getElementById("printable-section").style.display = "block";
            // }, 1000);

            let reportTitle = contentId == "printsubreport" ? this.subReportData.reportTitle : this.subReportData2.reportTitle
            let fileName = reportTitle.replace(/[^a-zA-Z0-9]/g,'_');
            document.title = fileName.replace(/ /g,'') + '-Report_' + this.$root.fn_getCurrentDateTimeString();
        }

        if((this.$root.dataObj.reportData && this.$root.dataObj.reportData.headerRow && this.$root.dataObj.reportData.headerRow.length > 8) || (this.$route.params.reportId==801 || this.$route.params.reportId==802 || this.$route.params.reportId==803 || this.$route.params.reportId==804 || this.subReportData)){
            let css = '@page { size: landscape; }';
            let head = document.head || document.getElementsByTagName('head')[0];
            let style = document.createElement('style');

            style.type = 'text/css';
            style.media = 'print';

            if (style.styleSheet){
                style.styleSheet.cssText = css;
            } else {
                style.appendChild(document.createTextNode(css));
            }

            head.appendChild(style);

            setTimeout(() => {
                head.removeChild(style);
            }, 1000);
        }


        setTimeout(() => {
            document.title = '';
        }, 1000);

        window.print();
    },

    fn_openDialogAndroid: function(){
        if(this.$root.dataObj.itemLabel == 'Party'){
            // this.fn_accountLedgers('android', 'AccountLedger', null);
            this.fn_accountLedgers();
        }
        else if(this.$root.dataObj.itemLabel == 'Item'){
            // this.fn_items('android', 'Item', null);
            this.fn_items();
        }
    },

    fn_accountLedgers: function(val){
      let filterObject = {};
      // filterObject.limit = 1000;
      // filterObject.startIndex = 0;
      filterObject.search = val ? val.toLowerCase() : '';

      // if(this.$root.dataObj.selectedAccountGroupTypeId){
      //   filterObject.groupTypeId = this.$root.dataObj.selectedAccountGroupTypeId;
      // }
      // else{
      //   filterObject.groupTypeId = 101;
      // }
      
      let self = this;
      this.getDialogItems("AccountDialog", filterObject, 
        {
          onSuccess: function (response) {
            console.log(response);
            self.parties = JSON.parse(response);
          },
          onError: function (error) {
            console.log(error);
          }
        }
      )
    },

    // fn_accountLedgers: function (platform, name, ref) {

    //     var tagId = this.guidWeb();

    //     var dialogObj = {};
    //     dialogObj.tagId = tagId;
    //     dialogObj.formId = this.formId;
    //     dialogObj.name = name;
    //     dialogObj.ref = ref;
    //     dialogObj.platform = platform;

    //     var viewDialogObject = {};
    //     viewDialogObject.ToolbarTitle = "Select Ledger";
    //     viewDialogObject.isBottomMenu = false;
    //     viewDialogObject.hideChip = true;
    //     viewDialogObject.enableFilterChip = true;

    //     if(this.$root.dataObj.selectedAccountGroupTypeId){
    //       viewDialogObject.groupTypeId = this.$root.dataObj.selectedAccountGroupTypeId;
    //     }
    //     else{
    //       viewDialogObject.groupTypeId = 101; 
    //     }

    //     var paramObject = {};
    //     paramObject.defaultValue = {"id":null, "name":null};

    //     if(this.$root.dataObj.itemId && this.$root.dataObj.itemName){
    //       paramObject.defaultValue = {"id":this.$root.dataObj.itemId, "name":this.$root.dataObj.itemName};
    //       this.fn_getPartyData(this.$root.dataObj.itemId, dialogObj, viewDialogObject, tagId, paramObject, ref)
    //     }
    //     else{
    //       dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
    //     }
        
    // },

    fn_getPartyData: function(itemId, dialogObj, viewDialogObject, tagId, paramObject, ref){
        let self = this;
        this.getData('Ledger', itemId, 
        {
          onSuccess: function(response){
              console.log(response);
              let partyData = JSON.parse(response);
              if(partyData){
                // self.partyGroupTypeId = partyData.groupTypeId;
                self.fn_selectedGroupTypeId(partyData.groupTypeId);
                viewDialogObject.groupTypeId = partyData.groupTypeId;
                dialogjs.fn_openDialog(self, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
              }
          }, 
          onError: function(error){
              console.log(error);
              // self.hideLoading();
          }
        }
      );
    },

    fn_selectedGroupTypeId: function(groupTypeId){
      this.$root.dataObj.selectedAccountGroupTypeId = Number(groupTypeId);
    },

    // fn_items: function (platform, name, ref) {

    //     var tagId = this.guidWeb();

    //     var dialogObj = {};
    //     dialogObj.tagId = tagId;
    //     dialogObj.formId = this.formId;
    //     dialogObj.name = name;
    //     dialogObj.ref = ref;
    //     dialogObj.platform = platform;

    //     var viewDialogObject = {};
    //     viewDialogObject.ToolbarTitle = "Select Item";
    //     viewDialogObject.isBottomMenu = false;
    //     viewDialogObject.hideChip = true;

    //     if(this.$route.params.reportId == 101){
    //       viewDialogObject.groupTypeId = 101;
    //       viewDialogObject.inventory = 1;
    //     }

    //     var paramObject = {};
    //     paramObject.defaultValue = {"id":null, "name":null};

    //     if(this.$root.dataObj.itemId && this.$root.dataObj.itemName){
    //         paramObject.defaultValue = {"id":this.$root.dataObj.itemId, "name":this.$root.dataObj.itemName};
    //     }
        
    //     dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'product', tagId, paramObject, ref);
    // },

    fn_items: function(val){
      let filterObject = {};
      // filterObject.limit = 1000;
      // filterObject.startIndex = 0;
      filterObject.search = val ? val.toLowerCase() : '';

      if(this.$route.params.reportId == 101){
        filterObject.groupTypeId = 101;
        filterObject.inventory = 1;
      }

      let self = this;
      this.getDialogItems("ProductDialog", filterObject, 
        {
          onSuccess: function (response) {
            console.log(response);
            self.items = JSON.parse(response);
          },
          onError: function (error) {
            console.log(error);
          }
        }
      )
    },

    fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
      if(ref!='null'){
        // this.$refs['ref_filter'].fn_updateItem(selectedValueId, selectedValueName, isRemoved, ref);
        this.fn_updateFilterItem(selectedValueId, selectedValueName, isRemoved, ref);
      }
      else{
        this.fn_updateItem(selectedValueId, selectedValueName, isRemoved);
      }
    },

    fn_updateItem: function(selectedValueId, selectedValueName, isRemoved, nextRoute){
        if(!isRemoved){
            this.$root.dataObj.itemId = selectedValueId;
            this.$root.dataObj.itemName = selectedValueName;
            // this.fn_getPartyData(selectedValueId);
            nextRoute && nextRoute.query.isFilter ? this.fn_updateFilter(nextRoute) : this.fn_getReportData();
            this.$forceUpdate();
        }
    },

    fn_openDialogWeb: function (platform, name, ref) {

        let scroll_y = window.scrollY;
        this.fn_fixBackgroundScroll();

        var tagId = this.guidWeb();

        var dialogObj = {};
        dialogObj.tagId = tagId;
        dialogObj.formId = this.formId;
        dialogObj.name = name;
        dialogObj.ref = ref;
        dialogObj.data = null;
        dialogObj.platform = platform;

        dialogObj.scrollPosition = {};
        dialogObj.scrollPosition.x = 0;
        dialogObj.scrollPosition.y = scroll_y;

        dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

        this.$refs[ref].openDialogWeb();
    },

    fn_closeDialog: function () {
        dialogjs.fn_checkAndCloseOpenDialogs(this);
    },

    fn_goBack: function(){
        this.$route.query.subreport == 2 ? this.subReportData2 = null : '';
        this.$router.go(-1);
    },

    fn_closeAndExportExcelFile: function(fileId){
        let self = this;
        this.closeFile(fileId, {

          onSuccess: function(response){
              console.log(response);
              if(self.shareExcel){
                self.fn_shareReport('xlsx');
              }
              else{
                self.showToast('File downloaded');
                self.snackbar = true;  
              }
          }, 
          onError: function(error){
              console.log(error);
              self.showToast('File download failed');
          }

        });
    },

    // fn_exportToExcel: function(data, fileName){
    //     let self = this;
    //     this.exportToExcel(data, fileName,{

    //       onSuccess: function(response){
    //           console.log(response);
    //           if(self.shareExcel){
    //             self.fn_shareReport('xlsx');
    //           }
    //           else{
    //             self.showToast('File downloaded');
    //             self.snackbar = true;  
    //           }
    //       }, 
    //       onError: function(error){
    //           console.log(error);
    //           self.showToast('File download failed');
    //       }

    //     });
    // },

    fn_exportToPdf: function(fileName, share){
        let self = this;
        this.exportToPdf(fileName,{

          onSuccess: function(response){
              console.log(response);
              if(share){
                self.fn_shareReport('pdf');
              }
              else{
                self.showToast('File downloaded');
                self.snackbar = true;
              }
          },
          onError: function(error){
              console.log(error);
              self.showToast('File download failed');
          }
        });
    },

    fn_shareReport: function(type){
      let shareObj = {};
      shareObj.type = type;
      shareObj.primaryMobileNumber = null
      shareObj.subject = this.$root.dataObj.reportTitle;
      shareObj.email = null
      shareObj.textMessage = null;
      this.$root.fn_share(shareObj)
    },

    fn_openTransaction: function(listId, transactionId){

      let transactionListId = Number(listId);

      let title = null;
      for(let i=0;i<transactionForms.length;i++){
        if(transactionListId == transactionForms[i].id){
          title = transactionForms[i].title;
          break;
        }
      }

      this.$router.push({path:'/'+this.$root.CurrentBusiness.BusinessID+'/'+this.$route.params.listId+'/'+title.toLowerCase().replace(/ /g,'')+'/items/'+transactionId, query:{"back":1}});
      
    },

    fn_openAccountDetails: function(accountId){
      // this.$router.push({path:"/masters/accounts/ledgers/items/"+accountId});
      this.$router.push({path:'/'+this.$root.CurrentBusiness.BusinessID+'/'+this.$route.params.listId+'/ledger/items/'+accountId, query:{back:1}});
    },

    fn_openFilterDialog: function (name, ref, id, value, dialogName) {

        var tagId = this.guidWeb();

        var dialogObj = {};
        dialogObj.tagId = tagId;
        dialogObj.formId = this.formId;
        dialogObj.name = name;
        dialogObj.ref = ref;
        dialogObj.platform = 'android';

        var viewDialogObject = {};
        viewDialogObject.ToolbarTitle = "Select "+name;
        viewDialogObject.isBottomMenu = false;
        name == 'Brand' ? viewDialogObject.listId = listIdObject.brandListGUID : '';
        name == 'Prescriber' ? viewDialogObject.listId = listIdObject.prescriberListGUID : '';
        let reportId = this.$route.params.reportId;

        if(name=='Transaction Form'){
          reportId == 303 || reportId == 312 ? viewDialogObject.transactionTypeId = [10003] : '';
          reportId == 403 || reportId == 419 ? viewDialogObject.transactionTypeId = [20003, 20005] : '';
        }

        if(reportId == 302){
          viewDialogObject.accountGroupIds = [accountGroupIds.debtors.id]; 
        }
        else if(reportId == 402){
          viewDialogObject.accountGroupIds = [accountGroupIds.creditors.id]; 
        }

        if(reportId == 401 || reportId == 403 || reportId == 404 || reportId == 405 || reportId == 409 || reportId == 418 || reportId == 419 || reportId == 420){
          if((reportId == 403 || reportId == 419) && name == 'Tax Type'){
            viewDialogObject.accountGroupIds = [accountGroupIds.purchaseAccount.id];
          }
          else{
            viewDialogObject.enableFilterChip = true;
            if(this.$root.dataObj.selectedAccountGroupTypeId){
              viewDialogObject.groupTypeId = this.$root.dataObj.selectedAccountGroupTypeId;
            }
            else{
              viewDialogObject.groupTypeId = 102;
            }
          }
          // else{
          //   viewDialogObject.accountGroupIds = [accountGroupIds.creditors.id];
          // }
        }
        else if(reportId == 101 || reportId == 202 || reportId == 203 || reportId == 301 || reportId == 303 || reportId == 304 || reportId == 305 || reportId == 308 || reportId == 411){
        if((reportId == 303 || reportId == 312) && name == 'Tax Type'){
            viewDialogObject.accountGroupIds = [accountGroupIds.saleAccount.id];
          }
          else{
            viewDialogObject.enableFilterChip = true;
            if(this.$root.dataObj.selectedAccountGroupTypeId){
              viewDialogObject.groupTypeId = this.$root.dataObj.selectedAccountGroupTypeId;
            }
            else{
              viewDialogObject.groupTypeId = 101;
            }
          }
          // else{
          //   viewDialogObject.accountGroupIds = [accountGroupIds.debtors.id];
          //   reportId == 101 ? viewDialogObject.accountGroupIds.push(accountGroupIds.brandAndDivision.id) : '';
          // }
        }

        // // enabling chip filters in case of party/account dialog filter
        // if(ref == 'ref_fieldParty'){
        //   viewDialogObject.enableFilterChip = true;
        //   if(this.partyGroupTypeId){
        //     viewDialogObject.groupTypeId = this.partyGroupTypeId;
        //   }
        //   if(this.$root.dataObj.selectedAccountGroupTypeId){
        //     viewDialogObject.groupTypeId = this.$root.dataObj.selectedAccountGroupTypeId;
        //   }
        //   else if(reportId == 301 || reportId == 303 || reportId == 304 || reportId == 305 || reportId == 308){
        //     viewDialogObject.groupTypeId = 101;
        //   }
        //   else if(reportId == 401 || reportId == 403 || reportId == 404 || reportId == 405 || reportId == 409){
        //     viewDialogObject.groupTypeId = 102;
        //   }
        // }

        var paramObject = {};
        paramObject.defaultValue = {"id":null, "name":null};

        if(id && value){
            paramObject.defaultValue = {"id":id, "name":value};
        }
        
        if(ref=='ref_fieldTransactionForm'){
          this.fn_getExcludeGroups(dialogObj, viewDialogObject, dialogName, tagId, paramObject, ref);  
        }
        else if((ref=='ref_fieldParty' || ref=='ref_fieldParties') && id && value){
          this.fn_getPartyData(id, dialogObj, viewDialogObject, tagId, paramObject, ref)
        }
        // else if(ref=='ref_fieldParty'){
        //   // enabling chip filters in case of party/account dialog filter
        //   viewDialogObject.enableFilterChip = true;
        //   if(this.$root.dataObj.selectedAccountGroupTypeId){
        //     viewDialogObject.groupTypeId = this.$root.dataObj.selectedAccountGroupTypeId;
        //   }
        //   else if(reportId == 401 || reportId == 403 || reportId == 404 || reportId == 405 || reportId == 409){
        //     viewDialogObject.groupTypeId = 102;
        //   }
        //   else{
        //     viewDialogObject.groupTypeId = 101;
        //   }

        //   // getting party groupTypeId if already selected else open dialog
        //   if(id && value){
        //     this.fn_getPartyData(id, dialogObj, viewDialogObject, tagId, paramObject, ref);
        //   }
        //   else{
        //     dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, dialogName, tagId, paramObject, ref);  
        //   }

        // }
        else{
          dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, dialogName, tagId, paramObject, ref);
        }
        
    },

    fn_getExcludeGroups: function(dialogObj, viewDialogObject, dialogName, tagId, paramObject, ref){
      let filterObject = {};
      filterObject.accountGroupsHidden = [2];

      let self = this;
      this.getFilterData('ExcludeGroups', null, filterObject, null,
        {
          onSuccess: function(response){
            console.log(response);
            viewDialogObject.accountGroupsHidden = JSON.parse(response);
            dialogjs.fn_openDialog(self, dialogObj, viewDialogObject, dialogName, tagId, paramObject, ref);
          }, 
          onError: function(error){
            console.log(error);
          }
        }
      );
    },

    fn_clearAllFilters: function(filterObj){
      let dataConfig = JSON.parse(JSON.stringify(require('../data_config/'+this.fn_getReportDataFileName()).data.fn_getData(this.$route.params.reportId)));
      // JSON.parse(JSON.stringify(require('./data.js').data.fn_getData(this.reportId)));
      let dateObj = this.fn_getTimeSpan(dataConfig.period);
      this.$root.dataObj.startDate = dateObj.startDate;
      this.$root.dataObj.endDate = dateObj.endDate;
      this.fn_getReportData(filterObj);
      this.fn_closeFilters();
    },

    fn_getReportDataFileName: function(){
      // return "data_registered.js";
        if(this.$root.CurrentBusiness.GSTRegistrationStatus==1)
            return "data_registered.js";
        else if(this.$root.CurrentBusiness.GSTRegistrationStatus==2)
            return "data_composite.js";
        else if(this.$root.CurrentBusiness.GSTRegistrationStatus==3)
            return "data_unregistered.js";
    },

    fn_openDialogTaxRateList: function(closeDialog){
      if(closeDialog){
        // this.fn_closeDialog();

        let self = this;
        setTimeout(function(){
        //   self.fn_openDialogWeb('web', 'TaxRateList', 'ref_dialogTaxRateList');
            self.$refs['ref_dialogTaxRateList'].openDialogWeb();
        },300)
      }
      else{
        if(this.compTaxRate.type==2){
          this.fn_openDialogCompTaxRate();
        }
        else{
        //   this.fn_openDialogWeb('web', 'TaxRateList', 'ref_dialogTaxRateList');
            this.$refs['ref_dialogTaxRateList'].openDialogWeb();
        }
      }
    },

    fn_openDialogCompTaxRate: function(){
    //   this.fn_openDialogWeb('web', 'CompTaxRate', 'ref_dialogCompTaxRate');
        this.$refs['ref_dialogCompTaxRate'].openDialogWeb();
    },

    fn_updateTaxRate: function(taxRate, type){
        //   this.fn_closeDialog();
        this.$refs['ref_dialogTaxRateList'].closeDialogWeb();
        this.$refs['ref_dialogCompTaxRate'].closeDialogWeb();
        if(taxRate == 'custom'){
            let self = this;
            this.compTaxRate.value = null;
            this.compTaxRate.type = 2;
            setTimeout(function(){
                self.fn_openDialogCompTaxRate();
            },300);
        }
        else{
            // this.fn_closeDialog();
            this.compTaxRate.value = taxRate;
            this.compTaxRate.type = type ? type : 1;
            let valueObj = {};
            valueObj.taxRate = this.compTaxRate.value;
            valueObj.type = this.compTaxRate.type;
            this.fn_postReportPreferences(804, valueObj);
        }
        // this.compTaxRate = taxRate
    },

    fn_initializeData: function(itemId, itemName, nextRoute){
      // this.reportId = !this.reportId ? this.$route.params.reportId : '';
      this.$root.reportFilterObj = {};

      // let dataFileName = null;

      // if(this.$root.CurrentBusiness.GSTRegistrationStatus==1)
      //   dataConfig = JSON.parse(JSON.stringify(require('./data_config/'+dataFileName).data.fn_getData(this.reportId)));
      // else if(this.$root.CurrentBusiness.GSTRegistrationStatus==2)
      //   dataConfig = JSON.parse(JSON.stringify(require('./data_config/data_composite.js').data.fn_getData(this.reportId)));
      // else if(this.$root.CurrentBusiness.GSTRegistrationStatus==3)
      //   dataConfig = JSON.parse(JSON.stringify(require('./data_config/data_unregistered.js').data.fn_getData(this.reportId)));

      dataConfig = JSON.parse(JSON.stringify(require('../data_config/'+this.fn_getReportDataFileName()).data.fn_getData(this.$route.params.reportId)));

      // this.$root.reportFilters = JSON.parse(JSON.stringify(require('./data_config/data_registered.js').data.filters));
      this.$root.reportFilters = JSON.parse(JSON.stringify(require('../data_config/'+this.fn_getReportDataFileName()).data.filters));

      if(this.$root.CurrentBusiness && this.$root.CurrentBusiness.GSTRegistrationStatus==2){
        this.compTaxRateList = JSON.parse(JSON.stringify(require('../data_config/'+this.fn_getReportDataFileName()).data.taxRates));
      }

      this.$root.dataObj.reportTitle = dataConfig.reportTitle;
      // this.$root.dataObj.itemId = itemId ? itemId : null;
      // this.$root.dataObj.itemName = itemName ? itemName : null;

      if(itemId && itemName){
        this.$root.dataObj.itemId = itemId;
        this.$root.dataObj.itemName = itemName;
        this.$root.dataObj.itemObj = {"itemId":this.$root.dataObj.itemId, "itemName":this.$root.dataObj.itemName};  
      }
      else{
        this.$root.dataObj.itemId = null;
        this.$root.dataObj.itemName = null;
        this.$root.dataObj.itemObj = null;
      }

      this.$root.dataObj.columns = dataConfig.columns;

      this.$root.dataObj.tileViewColumns = dataConfig.tileViewColumns;
      this.$root.dataObj.tileContent = dataConfig.tileContent;
      this.$root.dataObj.footerContent = dataConfig.footerContent;
      this.$root.dataObj.tileViewFooterHeaders = dataConfig.tileViewFooterHeaders;
      
      this.$root.dataObj.footerColumns = dataConfig.footerColumns ? dataConfig.footerColumns : null;
      this.$root.dataObj.itemLabel = dataConfig.itemLabel;
      this.$root.dataObj.periodLabel = dataConfig.periodLabel;

      // removing sales man filter if not enabled from settings
      if(!this.$root.TransactionSettings.enableSalesman){
        let fIndex = this.$root.reportFilters.findIndex(item=>{return item.ref == 'ref_fieldSalesman'});
        this.$root.reportFilters.splice(fIndex, 1);
      }
      // removing broker filter if not enabled from settings
      if(!this.$root.TransactionSettings.enableBroker){
        let fIndex = this.$root.reportFilters.findIndex(item=>{return item.ref == 'ref_fieldBroker'});
        this.$root.reportFilters.splice(fIndex, 1);
      }

      if(!this.$root.TransactionSettings.enableGodown){
        let fIndex = this.$root.reportFilters.findIndex(item=>{return item.ref == 'ref_fieldGodown'});
        this.$root.reportFilters.splice(fIndex, 1);
      }
      
      this.$root.dataObj.openView = dataConfig.openView
      this.$root.dataObj.hideFilterBtn = dataConfig.hideFilterBtn ? dataConfig.hideFilterBtn : false;

      this.$root.dataObj.reportData = {"headerRow":null};
      this.$root.dataObj.detailReportId = null;

      //Setting up default period report wise

      let defaultDateObj = this.fn_getTimeSpan(dataConfig.period);
      // defaultDateObj.startDate = new Date("2021/04/01");
      // defaultDateObj.endDate = new Date("2022/03/31");

      if(localStorage.getItem('report_period_'+this.reportId)){
        let periodObj = JSON.parse(localStorage.getItem('report_period_'+this.reportId));
        this.$root.dataObj.startDate = periodObj.startDate ? periodObj.startDate : defaultDateObj.startDate;
        this.$root.dataObj.endDate = periodObj.endDate ? periodObj.endDate : defaultDateObj.endDate;
        this.$root.dataObj.selectedPeriod = periodObj.selectedPeriod;
      }
      // else if(nextRoute && nextRoute.query && (nextRoute.query.startDate && nextRoute.query.endDate)){
      else if(nextRoute && nextRoute.query && nextRoute.query.endDate){
        this.$root.dataObj.startDate = nextRoute.query.startDate ? nextRoute.query.startDate : defaultDateObj.startDate;
        this.$root.dataObj.endDate = nextRoute.query.endDate ? nextRoute.query.endDate : defaultDateObj.endDate;
        // nextRoute.query.selectedPeriod ? this.$root.dataObj.selectedPeriod = nextRoute.query.selectedPeriod : '';
        this.$root.dataObj.selectedPeriod = nextRoute.query.selectedPeriod ? nextRoute.query.selectedPeriod : null;
      }
      else{
        this.$root.dataObj.startDate = defaultDateObj.startDate;
        this.$root.dataObj.endDate = defaultDateObj.endDate;
      }

      // if(dataConfig.detailReportId){
      //   this.$root.dataObj.detailReportId = dataConfig.detailReportId;
      //   this.detailReportObj = JSON.parse(JSON.stringify(require('./data_config/'+this.fn_getReportDataFileName()).data.fn_getData(dataConfig.detailReportId)));
      // }

      this.$root.dataObj.reportType = dataConfig.reportType;

      if(!dataConfig.openDialog){
        // this.fn_getReportData();
        if(nextRoute && nextRoute.query && nextRoute.query.isFilter){
          this.fn_updateFilter(nextRoute);
        }
        else{
          // this.fn_getReportData();
          if(this.reportId == 804){
            if(!this.$root.dataObj.reportPreferences){
              this.fn_openDialogTaxRateList();
            }
            else{
              this.fn_updateFilterItem(null, this.$root.dataObj.reportPreferences.value.taxRate, false, 'ref_compTaxRate');
              // this.$refs['ref_filter'].fn_updateItem(null, this.$root.dataObj.reportPreferences.value.taxRate, false, 'ref_compTaxRate');
            }
          }
          else{
            this.fn_getReportData();
          }
        }
      }
      else{
        this.fn_openDialogAndroid();
        if(this.$root.dataObj.itemId && this.$root.dataObj.itemName){
          this.$root.dataObj.itemObj = {"itemId":this.$root.dataObj.itemId, "itemName":this.$root.dataObj.itemName};
          this.fn_updateItem(this.$root.dataObj.itemId, this.$root.dataObj.itemName, false, nextRoute);
        }
        else{
          this.$root.dataObj.itemObj = null;
          // let self = this;
          setTimeout(function(){
            document.getElementById("item_selection").click();
          },100);
        }
        // else{
        //   this.fn_openDialogAndroid();
        // }
      }
      
      console.log(this.$root.dataObj);
    },

    fn_updateFilter: function(nextRoute){
      if(nextRoute.query.filterPartyId && nextRoute.query.filterPartyName){
        this.fn_updateFilterItem(nextRoute.query.filterPartyId, nextRoute.query.filterPartyName, false, "ref_fieldParty");
        // let self = this;
        // setTimeout(function(){
        //   self.$refs['ref_filter'].fn_updateItem(nextRoute.query.filterPartyId, nextRoute.query.filterPartyName, false, "ref_fieldParty");  
        // },2000);
      }
      else if(nextRoute.query.filtertypeFormName == "Expense"){
        this.fn_updateFilterItem(transactionTypeForms.expense.id, transactionTypeForms.expense.name, false, "ref_fieldTransactionForm");
      }
    },

    fn_updateFilterItem: function(selectedValueId, selectedValueName, isRemoved, ref){
        for(let i=0; i<this.$root.reportFilters.length; i++){
            if(this.$root.reportFilters[i].ref == ref){
                if(!isRemoved){
                    // this.$root.reportFilters[i].itemId = selectedValueId;
                    // this.$root.reportFilters[i].itemName = selectedValueName;
                    this.$root.reportFilters[i].value = {'itemId':selectedValueId, 'itemName':selectedValueName};
                    this.fn_applyFilter(selectedValueId, selectedValueName, ref);
                    break;
                }
                else{
                    // this.$root.reportFilters[i].itemId = null;
                    // this.$root.reportFilters[i].itemName = null;
                    this.$root.reportFilters[i].value = null;
                    this.fn_closeDialog();
                    this.fn_applyFilter(null, null, ref);
                    break;
                }
            }
        }
    },

    fn_applyFilter: function(selectedValueId, selectedValueName, ref){
        // this.fn_closeFilters();

        if(ref=='ref_fieldParty')
            selectedValueId ? this.$root.reportFilterObj.party = {"id":selectedValueId, "name":"Party", "value":selectedValueName}: delete this.$root.reportFilterObj.party;
        if(ref=='ref_fieldItem')
            selectedValueId ? this.$root.reportFilterObj.product = {"id":selectedValueId, "name":"Product", "value":selectedValueName}: delete this.$root.reportFilterObj.product;
        if(ref=='ref_fieldCategory')
            selectedValueId ? this.$root.reportFilterObj.category = {"id":selectedValueId, "name":"Category", "value":selectedValueName}: delete this.$root.reportFilterObj.category;
        if(ref=='ref_fieldBrand')
            selectedValueId ? this.$root.reportFilterObj.brand = {"id":selectedValueId, "name":"Brand", "value":selectedValueName}: delete this.$root.reportFilterObj.brand;
        if(ref=='ref_fieldTaxType')
            selectedValueId ? this.$root.reportFilterObj.taxType = {"id":selectedValueId, "name":"Tax Type", "value":selectedValueName}: delete this.$root.reportFilterObj.taxType;
        if(ref=='ref_fieldTransactionForm')
            selectedValueId ? this.$root.reportFilterObj.transactionTypeForm = {"id":selectedValueId, "name":"Transaction Form", "value":selectedValueName}: delete this.$root.reportFilterObj.transactionTypeForm;
        if(ref=='ref_fieldAccountGroup')
            selectedValueId ? this.$root.reportFilterObj.accountGroup = {"id":selectedValueId, "name":"Account Group", "value":selectedValueName}: delete this.$root.reportFilterObj.accountGroup;
        if(ref=='ref_fieldPrescriber')
            selectedValueId ? this.$root.reportFilterObj.prescriber = {"id":selectedValueId, "name":"Prescriber", "value":selectedValueName}: delete this.$root.reportFilterObj.prescriber;
        if(ref=='ref_fieldSalesman')
          selectedValueId ? this.$root.reportFilterObj.salesman = {"id":selectedValueId, "name":"Salesman", "value":selectedValueName}: delete this.$root.reportFilterObj.salesman;
        if(ref=='ref_fieldBroker')
          selectedValueId ? this.$root.reportFilterObj.broker = {"id":selectedValueId, "name":"Broker", "value":selectedValueName}: delete this.$root.reportFilterObj.broker;
        if(ref=='status')
            selectedValueName ? this.$root.reportFilterObj.status = {"id":null, "name":"Status", "value":selectedValueName}: delete this.$root.reportFilterObj.status;
        if(ref=='groupTypeId')
            selectedValueName ? this.$root.reportFilterObj.groupTypeId = {"id":null, "name":"Type", "value":selectedValueName}: delete this.$root.reportFilterObj.groupTypeId;
        if(ref=='ref_compTaxRate')
            selectedValueName ? this.$root.reportFilterObj.taxRate = {"id":null, "name":"GST Rate (%)", "value":selectedValueName}: delete this.$root.reportFilterObj.taxRate;
        if(ref=='showoutofstock')
            selectedValueName ? this.$root.reportFilterObj.showOutOfStock = {"id":null, "name":"Out of Stock", "value":selectedValueName}: delete this.$root.reportFilterObj.showOutOfStock;
        if(ref=='dueDays')
          selectedValueName ? this.$root.reportFilterObj.dueDays = {"id":null, "name":"Due Days", "value":Number(selectedValueName)}: delete this.$root.reportFilterObj.dueDays;
        if(ref=='showmsme')
          selectedValueName ? this.$root.reportFilterObj.showMSME = {"id":null, "name":"MSME", "value":selectedValueName}: delete this.$root.reportFilterObj.showMSME;
        if(ref=='showAllBatch')
          selectedValueName ? this.$root.reportFilterObj.showAllBatch = {"id":null, "name":"All Batches", "value":selectedValueName}: delete this.$root.reportFilterObj.showAllBatch;
        if(ref=='batchExpireIn')
          selectedValueName ? this.$root.reportFilterObj.batchExpireIn = {"id":null, "name":"Expire In", "value":selectedValueName}: delete this.$root.reportFilterObj.batchExpireIn;
        if(ref=='itemGroupType')
          selectedValueName ? this.$root.reportFilterObj.inventoryType = {"id":null, "name":"Type", "value":selectedValueName}: delete this.$root.reportFilterObj.inventoryType;
        if(ref=='ref_fieldGodown')
          selectedValueId ? this.$root.reportFilterObj.godown = {"id":selectedValueId, "name":"Godown", "value":selectedValueName}: delete this.$root.reportFilterObj.godown;
        if(ref=='ref_fieldParties'){
          !this.$root.reportFilterObj.parties ? this.$root.reportFilterObj.parties = [] : '';
          selectedValueId ? this.$root.reportFilterObj.parties.push({"id":selectedValueId, "name":selectedValueName}) : delete this.$root.reportFilterObj.parties;
        }
        if(ref=='stockType')
          selectedValueName ? this.$root.reportFilterObj.stockType = {"id":null, "name":"Stock Type", "value":selectedValueName}: delete this.$root.reportFilterObj.stockType;
        if(ref=='stockSummarySortBy')
          selectedValueName ? this.$root.reportFilterObj.stockSummarySortBy = {"id":null, "name":"Sort By", "value":selectedValueName}: delete this.$root.reportFilterObj.stockSummarySortBy;
        if(ref=='showZeroBalanceLedgers')
          selectedValueName ? this.$root.reportFilterObj.showZeroBalanceLedgers = {"id":null, "name":"Zero Balance Ledgers", "value":selectedValueName}: delete this.$root.reportFilterObj.showZeroBalanceLedgers;
        this.fn_getReportData(this.$root.reportFilterObj);
    },

    fn_changeView: function(){
      this.$root.dataObj.tableView = !this.$root.dataObj.tableView;

      localStorage.setItem('table_view', this.$root.dataObj.tableView);
      // localStorage.setItem("defaultReportView", this.$root.dataObj.dataObj.tableView);
      if(this.$root.dataObj.tableView && this.$root.dataObj.reportData && this.$root.dataObj.reportData.detailRows && this.$root.dataObj.reportData.detailRows.length){
          this.showLoading('Updating View...');
          this.fn_generateTable();
      }
      
    },

    fn_openPermissionDialog: function(permissionType){
        this.$root.permissionType = permissionType;
        this.fn_openDialogWeb('web', 'Permission', 'ref_dialogPermission');
    },

    fn_getTimeSpan: function(type, value, year){
            let dateObj = {};

            let minSelectionDate = new Date(this.$root.minDateSelection);
            // let minSelectionDate = this.$root.fn_getMinSelectionDate();
            let currentDate = new Date();
            let currentMonth = currentDate.getMonth() + 1;
            let thisFiscalYear = currentMonth<=3 ? currentDate.getFullYear() : currentDate.getFullYear() + 1;

            if(type=='monthly'){

                let now = null;

                // value == month number
                // if(value<=3){
                //     now = new Date("2022/"+value);
                // }
                // else{
                //     now = new Date();
                // }
                if(value<=3){
                    now = new Date((year+1)+"/"+value);
                }
                else{
                    now = new Date(year+"/"+value);
                }

                // let now = new Date();
                // last date of the month
                let endDate  = new Date(now.getFullYear(), value, 0);
                // first date of the month
                let startDate = new Date(now.getFullYear(), value-1, 1);

                let sDate = null;
                if(startDate.getTime() > minSelectionDate.getTime()){
                    sDate = startDate;
                }
                else{
                    sDate = minSelectionDate;
                }

                dateObj.startDate = formatDate(sDate);
                dateObj.endDate = formatDate(endDate);
            }
            
            // for current month / this month
            else if(type=='month'){
                let now = new Date();
                let endDate  = new Date(now.getFullYear(), now.getMonth()+1, 0);
                let startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

                // let minSelectionDate = new Date(this.$root.minDateSelection);

                let sDate = null;
                if(startDate.getFullYear() ==  minSelectionDate.getFullYear()){
                    if(startDate.getMonth()+1 > minSelectionDate.getMonth()+1){
                        sDate = startDate;
                    }
                    else{
                        sDate = minSelectionDate
                    }
                }
                else{
                    // sDate = minSelectionDate
                    sDate = startDate
                }

                // dateObj.startDate = formatDate(startDate);
                dateObj.startDate = formatDate(sDate);
                dateObj.endDate = formatDate(endDate);
                // dateObj.endDate = formatDate(now);
            }
            else if(type=='previousMonth'){
                let now = new Date();
                let sDate = new Date(now.getFullYear(), now.getMonth()-1, 1);
                let endDate  = new Date(now.getFullYear(), now.getMonth(), 0);
                dateObj.startDate = formatDate(sDate);
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='quarterly'){
                // let now = new Date();
                let now = null;

                // value == month number
                // if(value<=3){
                //     now = new Date("2022/"+value);
                // }
                // else{
                //     now = new Date("2021/"+value);
                // }
                if(value<=3){
                    now = new Date((year+1)+"/"+value);
                }
                else{
                    now = new Date(year+"/"+value);
                }

                let quarter = Math.floor((now.getMonth() / 3));
                let firstDate = new Date(now.getFullYear(), quarter * 3, 1);
                let endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);

                // let minSelectionDate = new Date(this.$root.minDateSelection);

                if(firstDate.getTime() < minSelectionDate.getTime()){
                    dateObj.startDate = formatDate(minSelectionDate); 
                }
                else{
                    dateObj.startDate = formatDate(firstDate);
                }
                
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='quarter'){
                let now = new Date();
                let quarter = Math.floor((now.getMonth() / 3));
                let firstDate = new Date(now.getFullYear(), quarter * 3, 1);
                let endDate = new Date(firstDate.getFullYear(), firstDate.getMonth() + 3, 0);

                // let minSelectionDate = new Date(this.$root.minDateSelection);

                if(firstDate.getTime() < minSelectionDate.getTime()){
                    dateObj.startDate = formatDate(minSelectionDate); 
                }
                else{
                    dateObj.startDate = formatDate(firstDate);
                }
                
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='year'){
                // let firstday = new Date(this.$root.minDateSelection);
                let endDate = new Date(this.$moment(new Date(thisFiscalYear+"/03/31")).endOf('day'));
                if(this.$root.fn_getMinSelectionDate() < new Date((thisFiscalYear-1)+"/04/01")){
                    dateObj.startDate = formatDate(new Date((thisFiscalYear-1)+"/04/01"));
                }
                else{
                    dateObj.startDate = formatDate(this.$root.fn_getMinSelectionDate());
                }
                // dateObj.startDate = formatDate(this.$root.fn_getMinSelectionDate());
                dateObj.endDate = formatDate(endDate);
            }
            else if(type=='fiscal_year'){
              let endDate = new Date(this.$moment(new Date((year+1)+"/03/31")).endOf('day'));
              let startDate = null;

              let openingYear = new Date(this.$root.minDateSelection).getFullYear();
              let openingMonth = new Date(this.$root.minDateSelection).getMonth() + 1;
              
              let minDateYear = openingMonth < 4 ? openingYear - 1 : openingYear;

              if(minDateYear == year){
                  startDate = new Date(this.$moment(this.$root.minDateSelection));
              }
              else if(minDateYear < year){
                  startDate = new Date(this.$moment(new Date(year+"/04/01")));
              }

              dateObj.startDate = formatDate(startDate);
              dateObj.endDate = formatDate(endDate);
            }
            else if(type=='alltime'){
                // let firstday = new Date(this.$root.minDateSelection);
                let maxDateYear = new Date(this.$root.maxDateSelection).getFullYear();
                let year = maxDateYear > thisFiscalYear ? maxDateYear : thisFiscalYear;
                let endDate = new Date(this.$moment(new Date(year+"/03/31")).endOf('day'));
                dateObj.startDate = formatDate(minSelectionDate);
                dateObj.endDate = formatDate(endDate);
            }
            // else if(type=='year' || type=='alltime'){
            //     let currentDate = new Date();
            //     let currentMonth = currentDate.getMonth() + 1;
            //     let currentFiscalYear = currentMonth <=3 ? currentDate.getFullYear() - 1 : currentDate.getFullYear();
            //     let currentFiscalYearStartDate = new Date(currentFiscalYear+"/04/01");

            //     let firstday = currentFiscalYearStartDate > new Date(this.$root.minDateSelection) ? currentFiscalYearStartDate : new Date(this.$root.minDateSelection);
            //     let startDate = new Date(this.$moment(firstday).startOf('day'));

            //     // let firstday = new Date(this.$root.minDateSelection);
            //     let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);
            //     let openingMonth = openingDate.getMonth() + 1;
            //     let openingYear = openingDate.getFullYear();
            //     openingMonth > 3 ? openingYear = openingYear + 1 : '';
            //     let endDate = new Date(this.$moment(new Date(openingYear+"/03/31")).endOf('day'));
            //     dateObj.startDate = formatDate(startDate);
            //     dateObj.endDate = formatDate(endDate);
            // }
            else if(type=='endDate'){
                dateObj.startDate = null;
                dateObj.endDate = new Date();
            }
            else if(type=='currentDate'){
                dateObj.startDate = this.$moment(new Date()).startOf('day');
                dateObj.endDate = this.$moment(new Date()).endOf('day');
            }
            else if(type=='previousDate'){
                let now = new Date();
                let yesterday = now.setDate(now.getDate() - 1);
                dateObj.startDate = this.$moment(yesterday).startOf('day');
                dateObj.endDate = this.$moment(yesterday).endOf('day');
            }
            else{
                dateObj.startDate = new Date();
                dateObj.endDate = new Date();
            }

            let filterStartDate = new Date(dateObj.startDate);
            let openingDate = new Date(this.$root.CurrentBusiness.OpeningDate);

            if(filterStartDate.getTime() < openingDate.getTime()){
                dateObj.startDate = formatDate(openingDate);

                if(type=='month'){
                    // last date of month
                    dateObj.endDate = new Date(openingDate.getFullYear(), openingDate.getMonth()+1, 0);
                }
            }

            dateObj.startDate = dateObj.startDate ? this.$root.fn_getLocalDateFormat(dateObj.startDate) : null;
            dateObj.endDate = this.$root.fn_getLocalDateFormat(dateObj.endDate);

            if(new Date(dateObj.endDate) < new Date(this.$root.CurrentBusiness.OpeningDate)){
                // alert('Selected period is not applicable!');
                this.$eventHub.$emit('snackbarAlert', {msg:'Selected period is not applicable'});
                dateObj.startDate = dateObj.endDate;
            }

            if(type == 'currentDate'){
                this.$root.dataObj.selectedPeriod = "Today";
            }
            else if(type == 'previousDate'){
                this.$root.dataObj.selectedPeriod = "Yesterday";
            }
            else if(type == 'month' || type == 'monthly' || type == 'previousMonth' || type == 'fiscal_year'){
                // this.selectedPeriod = "This Month";
                this.$root.dataObj.selectedPeriod = this.$moment(dateObj.startDate).format('MMM, YYYY');
            }
            else if(type == 'quarter' || type == 'quarterly'){
                // this.selectedPeriod = "This Quarter";
                this.$root.dataObj.selectedPeriod = this.$moment(dateObj.startDate).format('MMM') + ' - ' + this.$moment(dateObj.endDate).format('MMM');
            }
            else if(type == 'year'){
                this.$root.dataObj.selectedPeriod = "This Year";
            }
            else if(type == 'alltime'){
                this.$root.dataObj.selectedPeriod = "All Time";
            }
            else{
                this.$root.dataObj.selectedPeriod = null;
            }

            return dateObj;
        },

         fn_removeHeaderRows: function(){
          if(this.reportId == 101){
            let hIndex = dataConfig.headerRowTableHeaders.findIndex(item=>{return item.headerName == 'Pack Qty'});
            if(!this.$root.TransactionSettings.showPacking){
              dataConfig.headerRowTableHeaders.splice(hIndex, 1);
              delete dataConfig.headerRow.packing;
              dataConfig.columns.splice(hIndex);
            }
            else{
              if(hIndex != -1){
                dataConfig.headerRowTableHeaders[hIndex].headerName = this.$root.TransactionSettings.packingLabel;
              }
            }
          }
        },

        fn_processSecondaryUnitData: function(row, footerRow, index){
          if(this.reportId == 102){
            let secondaryUnitPackQty = row.cols['secondaryUnitPackQuantity'];
            if(secondaryUnitPackQty){
              row.cols['secondaryUnitPackQuantity'] = this.roundUpto2Decimals(secondaryUnitPackQty) + ' ' + row.cols['secondaryUnitName'];
              // fix for real qty double from android side
              // let rQty = row.cols['realQty'] / 2;
              // row.cols['totalSecondaryUnitPackQuantity'] = this.roundUpto2Decimals(((rQty * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
              row.cols['totalSecondaryUnitPackQuantity'] = this.roundUpto2Decimals(((row.cols['realQty'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
            }

            if(footerRow && footerRow.secondaryUnitPackQuantity && footerRow.packQuantity && index == 0){
              footerRow.totalSecondaryUnitPackQuantity = this.roundUpto2Decimals((footerRow.realQty * footerRow.secondaryUnitPackQuantity) / footerRow.packQuantity);
            }
          }
          else if(this.reportId == 101 || this.reportId == 103){
            let secondaryUnitPackQty = row.cols['secondaryUnitPackQuantity'];
            if(secondaryUnitPackQty){
              if(row.cols['inwardReal']){
                row.cols['secondaryUnitPackQuantityInward'] = this.roundUpto2Decimals(((row.cols['inwardReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
              }
              if(row.cols['outwardReal']){
                row.cols['secondaryUnitPackQuantityOutward'] = this.roundUpto2Decimals(((row.cols['outwardReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
              }
              if(row.cols['balanceReal']){
                row.cols['closingSecondaryUnitPackQuantity'] = this.roundUpto2Decimals(((row.cols['balanceReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
              }
              if(row.cols['closingReal']){
                row.cols['closingSecondaryUnitPackQuantity'] = this.roundUpto2Decimals(((row.cols['closingReal'] * secondaryUnitPackQty) / row.cols['packQuantity'])) + ' ' + row.cols['secondaryUnitName'];
              }
              if(footerRow && footerRow.actualInwardValueReal){
                footerRow.secondaryUnitPackQuantityInward = this.roundUpto2Decimals(((footerRow.actualInwardValueReal * footerRow.secondaryUnitPackQuantity) / footerRow.packQuantity)) + ' ' + footerRow.secondaryUnitName;
              }
              if(footerRow && footerRow.actualOutwardValueReal){
                footerRow.secondaryUnitPackQuantityOutward = this.roundUpto2Decimals(((footerRow.actualOutwardValueReal * footerRow.secondaryUnitPackQuantity) / footerRow.packQuantity)) + ' ' + footerRow.secondaryUnitName;
              }
              if(footerRow && footerRow.balanceReal){
                footerRow.closingSecondaryUnitPackQuantity = this.roundUpto2Decimals(((footerRow.balanceReal * footerRow.secondaryUnitPackQuantity) / footerRow.packQuantity)) + ' ' + footerRow.secondaryUnitName;
              }
            }
            
          }
        },

        fn_removeSecondaryUnitData: function(){
          if(this.reportId == 102){
            
            // let headerLength = dataConfig.headerRowTableHeaders.length;

            // // removing headers rows
            // dataConfig.headerRowTableHeaders.splice(headerLength - 1, 1);
            // dataConfig.headerRowTableHeaders.splice(headerLength - 2, 1);

            // dataConfig.columns.splice(headerLength - 1, 1);
            // dataConfig.columns.splice(headerLength - 2, 1);

            let qtyPackIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Qty (Per Pack)"});

            if(qtyPackIndex != -1){
              dataConfig.headerRowTableHeaders.splice(qtyPackIndex, 1);
              dataConfig.columns.splice(qtyPackIndex, 1);
            }

            let totalPackIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Total (Pack)"});

            if(totalPackIndex != -1){
              dataConfig.headerRowTableHeaders.splice(totalPackIndex, 1);
              dataConfig.columns.splice(totalPackIndex, 1);
            }

            delete dataConfig.headerRow.secondaryUnitPackQuantity;
            delete dataConfig.headerRow.totalSecondaryUnitPackQuantity;
          }
          else if(this.reportId == 101 || this.reportId == 103){

            let inwardIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Inward (Per Pack)"});
            
            if(inwardIndex != -1){
              dataConfig.headerRowTableHeaders.splice(inwardIndex, 1);
              dataConfig.columns.splice(inwardIndex, 1);
            }

            let outwardIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Outward (Per Pack)"});
            if(outwardIndex != -1){
              dataConfig.headerRowTableHeaders.splice(outwardIndex, 1);
              dataConfig.columns.splice(outwardIndex, 1);
            }

            let balanceIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Balance (Pack)"});
            if(balanceIndex != -1){
              dataConfig.headerRowTableHeaders.splice(balanceIndex, 1);
              dataConfig.columns.splice(balanceIndex, 1);
            }

            let closingIndex = dataConfig.headerRowTableHeaders.findIndex(head=>{return head.headerName == "Closing (Pack)"});
            if(closingIndex != -1){
              dataConfig.headerRowTableHeaders.splice(closingIndex, 1);
              dataConfig.columns.splice(closingIndex, 1);
            }

            delete dataConfig.headerRow.secondaryUnitPackQuantityInward;
            delete dataConfig.headerRow.secondaryUnitPackQuantityOutward;
            delete dataConfig.headerRow.closingSecondaryUnitPackQuantity;
          }
        },

        fn_beforeRouteEnter: function(vm){
          vm.reportId = vm.$route.params.reportId;

          // empty report data object before route enter
          vm.$root.dataObj.reportData = {"headerRow":null};

          vm.reportId == 801 || vm.reportId == 802 || vm.reportId == 803 ? vm.$root.dataObj.tableView = false : vm.$root.dataObj.tableView = true;

          if(localStorage.getItem("clearfilters")){
            reportList.forEach(item => {
              for(let i=0; i<item.items.length; i++) {
                localStorage.removeItem('report_period_'+item.items[i].reportId);
              }
            });

            localStorage.removeItem("clearfilters");

            vm.fn_getReportPreferences(vm.reportId);
          }
          else{
            if(vm.$root.dataObj.itemId && vm.$root.dataObj.itemName){
              vm.fn_openDialogAndroid();
              vm.$root.dataObj.itemObj = {"itemId":vm.$root.dataObj.itemId, "itemName":vm.$root.dataObj.itemName};
            }
            vm.fn_getReportData(vm.$root.reportFilterObj);
          }
        },

        fn_beforeRouteUpdate: function(to){
          this.customDates = false;

          if(localStorage.getItem("clearfilters")){
              reportList.forEach(item => {
                  for(let i=0; i<item.items.length; i++) {
                      localStorage.removeItem('report_period_'+item.items[i].reportId);
                  }
              });

              localStorage.removeItem("clearfilters");
          }

          let itemId =  to.query.itemId ? to.query.itemId : null;
          let itemName =  to.query.itemName ? to.query.itemName : null;
          this.reportId = to.params.reportId;
          
          if(localStorage.getItem("table_view")){
              this.reportId == 601 || this.reportId == 602 || this.reportId == 603 || this.reportId == 802 || this.reportId == 804 || this.reportId == 901 ? this.$root.dataObj.tableView = true : this.$root.dataObj.tableView = JSON.parse(localStorage.getItem("table_view"));
          }
          else{
              localStorage.setItem('table_view', this.$root.dataObj.tableView);
          }

          if(this.reportId == 505 || this.reportId == 604){
            localStorage.removeItem('report_period_'+this.reportId);
          }

          this.reportId == 801 || this.reportId == 802 || this.reportId == 803 ? this.$root.dataObj.tableView = false : this.$root.dataObj.tableView = true;
          
          !to.query.subreport ? this.fn_getReportPreferences(this.reportId, itemId, itemName, to) : '';
        }
},
mounted: function(){
  this.dialogStorageId = 'dialog_'+this.guidWeb();

  let self = this;
  setTimeout(function(){
    self.isGoBack = true;
  },500);
},
computed:{
    isDateSelectionValid: function(){
        if(new Date(this.selectedStartDate) > new Date(this.selectedEndDate)){
            return false;
        }
        else{
            return true;
        }
    },
    filteredProducts: function(){
        return this.$root.products.filter(item => {
          if(this.$route.params.reportId == 101 || this.$route.params.reportId == 105 || this.$route.params.reportId == 108 || this.$route.params.reportId == 109){
            return item.groupTypeId == 101 && item.inventory == 1;
          }
          else{
            return true;
          }
        })
    }
},
beforeRouteEnter (to, from, next) {
  next(vm => {
    vm.fn_beforeRouteEnter(vm);

    let isCalled = false;

    vm.$eventHub.$on('connected', () => {
        setTimeout(() => {
            if(!isCalled){
                isCalled = true;
                vm.fn_beforeRouteEnter(vm);
            }
        }, 1000);

        setTimeout(() => {
            isCalled = false;
        }, 3000);
    });
    
  })
},
beforeRouteUpdate(to, from, next){
    this.fn_beforeRouteUpdate(to);
    
    let isCalled = false;

    this.$eventHub.$on('connected', () => {
        setTimeout(() => {
            if(!isCalled){
                isCalled = true;
                this.fn_beforeRouteUpdate(this.$route);
            }
        }, 1000);

        setTimeout(() => {
            isCalled = false;
        }, 3000);
    });

    next();
},
beforeRouteLeave (to, from, next) {
    
    if(this.bottomSheet && to.name == 'reports'){
      this.bottomSheet = false;
      next(false);
    }
    else if(this.filter_sheet || this.tileViewDetailSheet || this.tileViewTotalSheet){
      this.filter_sheet = false;
      this.tileViewDetailSheet = false;
      this.tileViewTotalSheet = false
      next(false);
    }
    else{
      localStorage.removeItem('report_period_'+this.$route.params.reportId);
      this.$eventHub.$off('connected');
      next(true);
    }
}

}

function formatDate(date_obj){
  return date_obj.getFullYear() + "-" + ("0" + (date_obj.getMonth()+1)).slice(-2) + "-" + ("0" + date_obj.getDate()).slice(-2);
}

function formatDateForExcel(dateStr){
  let dateObj = new Date(dateStr);
  console.log(dateObj);
  return ("0" + dateObj.getDate()).slice(-2) + "/" + ("0" + (dateObj.getMonth()+1)).slice(-2) + "/" +  dateObj.getFullYear();
}

function prepareExcel(dataObj, self){

    let headerRow1 = [dataObj.otherData.headerRow1];
    let headerRow2 = [dataObj.otherData.headerRow2];
    let headerRow3 = [dataObj.otherData.headerRow3];
    let headerRow4 = dataObj.otherData.headerRow4 ? [dataObj.otherData.headerRow4] : null;
    //this row is for advance filters;
    let headerRow5 = dataObj.otherData.headerRow5 ? [dataObj.otherData.headerRow5] : null;

    let tableHeader = [];
    let headerCols = dataObj.reportDataObject.reportData.headerRow;

    let headerInternalCols = null;
    if(dataObj.reportDataObject.reportData.internalHeaderRow){
        headerInternalCols = dataObj.reportDataObject.reportData.internalHeaderRow;  
    }
    

    for(let key in headerCols){
      tableHeader.push(headerCols[key]);
      headerRow1.push(null);
      headerRow2.push(null);
      headerRow3.push(null);
      headerRow4 ? headerRow4.push(null) : '';
      headerRow5 ? headerRow5.push(null) : '';
    }

    // pushing null item to first header in case of header object keys length is shorter than internal header object keys length;
    if(headerInternalCols && headerRow1.length < Object.keys(headerInternalCols).length){
      let lengthDiff = Object.keys(headerInternalCols).length - headerRow1.length;
      for(let i=0; i<lengthDiff; i++){
        headerRow1.push(null);
      }
    }
    

    var excelData = [];
    excelData.push(headerRow1);
    excelData.push(headerRow2);
    excelData.push(headerRow3);

    let headerRowCount = 4;//headerRow1 + headerRow2 + headerRow3 + tableHeader

    if(headerRow4){
      excelData.push(headerRow4); 
      headerRowCount += 1;
    }

    if(headerRow5){
      excelData.push(headerRow5); 
      headerRowCount += 1;
    }

    excelData.push(tableHeader);

    for(var i=0; i<dataObj.reportDataObject.reportData.detailRows.length; i++){

      let tableRow = [];
      let item = dataObj.reportDataObject.reportData.detailRows[i];
      for(let key in headerCols){
        console.log(headerCols[key]+': '+item.cols[key]);
        if(headerCols[key]=='Date' || key=='transactionDate' || key=='shippingBillDate' || key=='referenceTransactionDate' || key=='expiryDate' || key=='expDate' || key=='mfgDate'){
          item.cols[key] = item.cols[key] ? formatDateForExcel(item.cols[key]) : '';
        }
        else if(key=='expiredIn'){
          item.cols[key] <= 0 ? item.cols[key] = '' : '';
        }
        tableRow.push(item.cols[key]);
      }

      excelData.push(tableRow);

      if(item.cols.otherTax && item.cols.otherTax.items && item.cols.otherTax.items.length){
              
        tableRow = [];
        for(var col in headerInternalCols){
          tableRow.push(headerInternalCols[col]);
        }
        excelData.push(tableRow);

        for(var j=0; j<item.cols.otherTax.items.length; j++){
          let otherItem = item.cols.otherTax.items[j];

          tableRow = [];
          for(let hCol in headerInternalCols){
            tableRow.push(otherItem[hCol]);
          }
          excelData.push(tableRow);
        }

        if(item.cols.otherTax.total){
          tableRow = [];
          for(let tCol in headerInternalCols){
              tableRow.push(item.cols.otherTax.total[tCol]);
          }
          excelData.push(tableRow); 
        }

      }

      if(item.cols.itemDetailRows && item.cols.itemDetailRows.length){
              
        tableRow = [];
        // for(var col in item.subHeaders){
        //   tableRow.push(item.subHeaders[col]);
        // }
        tableRow.push(item.subHeaders.srNo);
        tableRow.push(item.subHeaders.productName);
        item.subHeaders.hsnCode ? tableRow.push(item.subHeaders.hsnCode) : '';
        // tableRow.push(item.subHeaders.hsnCode);
        tableRow.push(item.subHeaders.qty);
        tableRow.push(item.subHeaders.unit);
        tableRow.push(item.subHeaders.rate);
        item.subHeaders.discount ? tableRow.push(item.subHeaders.discount) : '';
        // tableRow.push(item.subHeaders.discount)
        // tableRow.push(item.subHeaders.discount)
        tableRow.push(item.subHeaders.taxableValue);

        if(item.subHeaders.gstPercentage){
          tableRow.push(item.subHeaders.gstPercentage);
        }
        // item.subHeaders.cgst ? tableRow.push(item.subHeaders.cgst) : '';
        // item.subHeaders.sgst ? tableRow.push(item.subHeaders.sgst) : '';
        // item.subHeaders.igst ? tableRow.push(item.subHeaders.igst) : '';
        if(item.subHeaders.cgst){
          tableRow.push(item.subHeaders.cgst);
          if(item.subHeaders.utgst){
            tableRow.push(item.subHeaders.utgst);  
          }
          else{
            tableRow.push(item.subHeaders.sgst);  
          }
        }
        
        if(item.subHeaders.igst){
          tableRow.push(item.subHeaders.igst);
        }

        if(item.subHeaders.cessPercentage){
          tableRow.push(item.subHeaders.cessPercentage);
        }

        if(item.subHeaders.cessOnQtyPercentage){
          tableRow.push(item.subHeaders.cessOnQtyPercentage);
        }

        if(item.subHeaders.cess){
          tableRow.push(item.subHeaders.cess);
        }
        
        tableRow.push(item.subHeaders.total);

        excelData.push(tableRow);

        for(let j=0; j<item.cols.itemDetailRows.length; j++){
          let otherItem = item.cols.itemDetailRows[j];

          tableRow = [];
          if(item.subHeaders){
            // for(let hCol in item.subHeaders){
            //   tableRow.push(otherItem[hCol]);
            // }
            tableRow.push(otherItem.srNo);
            tableRow.push(otherItem.productName);
            item.subHeaders.hsnCode ? tableRow.push(otherItem.hsnCode) : '';
            // tableRow.push(otherItem.hsnCode)
            tableRow.push(otherItem.qty);
            tableRow.push(otherItem.unit);
            tableRow.push(otherItem.rate);
            item.subHeaders.discount ? tableRow.push(otherItem.discount) : '';
            // tableRow.push(otherItem.discount)
            tableRow.push(otherItem.taxableValue);

            if(item.subHeaders.gstPercentage){
              tableRow.push(otherItem.gstPercentage);
            }
            // otherItem.cgst ? tableRow.push(otherItem.cgst) : '';
            // otherItem.sgst ? tableRow.push(otherItem.sgst) : '';
            // otherItem.igst ? tableRow.push(otherItem.igst) : '';
            if(item.subHeaders.cgst){
              tableRow.push(otherItem.cgst);
              if(item.subHeaders.utgst){
                tableRow.push(otherItem.utgst); 
              }
              else{
                tableRow.push(otherItem.sgst);  
              }
            }
            
            if(item.subHeaders.igst){
              tableRow.push(otherItem.igst);
            }

            if(item.subHeaders.cessPercentage){
              tableRow.push(otherItem.cessPercentage);
            }

            if(item.subHeaders.cessOnQtyPercentage){
              tableRow.push(otherItem.cessOnQtyPercentage);
            }
            

            if(item.subHeaders.cess){
              tableRow.push(otherItem.cess);
            }

            tableRow.push(otherItem.total);
            excelData.push(tableRow);
          }
          
        }

        if(item.cols.subTotal){
          tableRow = [];
          tableRow.push(item.cols.subTotal.srNo);
          tableRow.push(item.cols.subTotal.productName);
          item.subHeaders.hsnCode ? tableRow.push(item.cols.subTotal.hsnCode) : '';
          // tableRow.push(item.cols.subTotal.hsnCode);
          tableRow.push(item.cols.subTotal.qty);
          tableRow.push(item.cols.subTotal.unit);
          tableRow.push(item.cols.subTotal.rate);
          item.subHeaders.discount ? tableRow.push(item.cols.subTotal.discount) : '';
          // tableRow.push(item.cols.subTotal.discount);
          tableRow.push(item.cols.subTotal.taxableValue);

          if(item.subHeaders.gstPercentage){
            tableRow.push(item.cols.subTotal.gstPercentage);
          }
          // item.cols.subTotal.cgst ? tableRow.push(item.cols.subTotal.cgst) : '';
          // item.cols.subTotal.sgst ? tableRow.push(item.cols.subTotal.sgst) : '';
          // item.cols.subTotal.igst ? tableRow.push(item.cols.subTotal.igst) : '';
          if(item.subHeaders.cgst){
            tableRow.push(item.cols.subTotal.cgst);
            if(item.subHeaders.utgst){
              tableRow.push(item.cols.subTotal.utgst);
            }
            else{
              tableRow.push(item.cols.subTotal.sgst);  
            }
          }
          
          if(item.subHeaders.igst){
            tableRow.push(item.cols.subTotal.igst);
          }

          if(item.subHeaders.cessPercentage){
            tableRow.push(item.cols.subTotal.cessPercentage);
          }

          if(item.subHeaders.cessOnQtyPercentage){
            tableRow.push(item.cols.subTotal.cessOnQtyPercentage);
          }

          if(item.subHeaders.cess){
            tableRow.push(item.cols.subTotal.cess);
          }
          tableRow.push(item.cols.subTotal.total);
          excelData.push(tableRow);
        }

        if(item.cols.billAddOns){
          tableRow = [];
          tableRow.push(item.cols.billAddOns.srNo);
          tableRow.push(item.cols.billAddOns.productName);
          item.subHeaders.hsnCode ? tableRow.push(item.cols.billAddOns.hsnCode) : '';
          // tableRow.push(item.cols.billAddOns.hsnCode);
          tableRow.push(item.cols.billAddOns.qty);
          tableRow.push(item.cols.billAddOns.unit);
          tableRow.push(item.cols.billAddOns.rate);
          item.subHeaders.discount ? tableRow.push(item.cols.billAddOns.discount) : '';
          // tableRow.push(item.cols.billAddOns.discount);
          tableRow.push(item.cols.billAddOns.taxableValue);

          if(item.subHeaders.gstPercentage){
            tableRow.push(item.cols.billAddOns.gstPercentage);
          }
          // item.cols.billAddOns.cgst ? tableRow.push(item.cols.billAddOns.cgst) : '';
          // item.cols.billAddOns.sgst ? tableRow.push(item.cols.billAddOns.sgst) : '';
          // item.cols.billAddOns.igst ? tableRow.push(item.cols.billAddOns.igst) : '';
          if(item.subHeaders.cgst){
            tableRow.push(item.cols.billAddOns.cgst);
            if(item.subHeaders.utgst){
              tableRow.push(item.cols.billAddOns.sgst);  
            }
            else{
              tableRow.push(item.cols.billAddOns.sgst);  
            }
          }
          
          if(item.subHeaders.igst){
            tableRow.push(item.cols.billAddOns.igst);
          }

          if(item.subHeaders.cess){
            tableRow.push(item.cols.billAddOns.cess);
          }

          if(item.subHeaders.cessPercentage){
            tableRow.push(item.cols.billAddOns.cessPercentage);
          }

          if(item.subHeaders.cessOnQtyPercentage){
            tableRow.push(item.cols.billAddOns.cessOnQtyPercentage);
          }

          tableRow.push(item.cols.billAddOns.total);
          excelData.push(tableRow);
        }

        if(item.cols.tdsAddOns){
          tableRow = [];
          tableRow.push('Total Tds');
          tableRow.push('');
          item.subHeaders.hsnCode ? tableRow.push('') : '';
          tableRow.push('');
          tableRow.push('');
          tableRow.push('');
          item.subHeaders.discount ? tableRow.push('') : '';
          tableRow.push('');
          item.subHeaders.gstPercentage ? tableRow.push('') : '';
          item.subHeaders.cgst ? tableRow.push('') : '';
          item.subHeaders.sgst ? tableRow.push('') : '';
          item.subHeaders.igst ? tableRow.push('') : '';
          item.subHeaders.cessPercentage ? tableRow.push('') : '';
          item.subHeaders.cessOnQtyPercentage ? tableRow.push('') : '';
          item.subHeaders.cess ? tableRow.push('') : '';
          tableRow.push(item.cols.tdsAddOns.total);
          excelData.push(tableRow);
        }

        if(item.cols.total){
          tableRow = [];
          tableRow.push(item.cols.total.srNo);
          tableRow.push(item.cols.total.productName);
          item.subHeaders.hsnCode ? tableRow.push(item.cols.total.hsnCode) : '';
          // tableRow.push(item.cols.total.hsnCode) 
          tableRow.push(item.cols.total.qty);
          tableRow.push(item.cols.total.unit);
          tableRow.push(item.cols.total.rate);
          item.subHeaders.discount ? tableRow.push(item.cols.total.discount) : '';
          // tableRow.push(item.cols.total.discount);
          tableRow.push(item.cols.total.taxableValue);

          if(item.subHeaders.gstPercentage){
            tableRow.push(item.cols.total.gstPercentage);
          }
          // item.cols.total.cgst ? tableRow.push(item.cols.total.cgst) : '';
          // item.cols.total.sgst ? tableRow.push(item.cols.total.sgst) : '';
          // item.cols.total.igst ? tableRow.push(item.cols.total.igst) : '';
          if(item.subHeaders.cgst){
            tableRow.push(item.cols.total.cgst);
            if(item.subHeaders.utgst){
              tableRow.push(item.cols.total.utgst);  
            }
            else{
              tableRow.push(item.cols.total.sgst);  
            }
          }
          
          if(item.subHeaders.igst){
            tableRow.push(item.cols.total.igst);
          }

          if(item.subHeaders.cessPercentage){
            tableRow.push(item.cols.total.cessPercentage);
          }

          if(item.subHeaders.cessOnQtyPercentage){
            tableRow.push(item.cols.total.cessOnQtyPercentage);
          }

          if(item.subHeaders.cess){
            tableRow.push(item.cols.total.cess);
          }
          tableRow.push(item.cols.total.total);
          excelData.push(tableRow);
        }


        // pushing empty cols as fixing uneven length of columns
          for(let m=0; m<excelData.length; m++){
            let emptyColLength = 16 - excelData[m].length;
            for(let n=0; n<emptyColLength; n++){
              excelData[m].push(null);
            }
          }

      }
    }

    let isFooterRow = false;
    let isSummaryRow = false;

    if(dataObj.reportDataObject.reportData.footerRow){
      let tableFooter = [];
      let footerCols = dataObj.reportDataObject.reportData.footerRow;

      if(headerInternalCols){
        for(let key in headerInternalCols){
          tableFooter.push(footerCols[key]);
        }  
      }
      else{
        for(let key in headerCols){
          tableFooter.push(footerCols[key]);
        }  
      }

      excelData.push(tableFooter);
      isFooterRow = true;
    }

    //only for outstanding recivable and payable reports
    if(dataObj.reportDataObject.reportData.summaryRows){
      let footerRows = dataObj.reportDataObject.reportData.summaryRows;
        let footerColumns = ['', '', 'mergeTransactionNumber', 'transactionListId'];
        for(let i=0; i<footerRows.length; i++){
          let tableFooter = [];
          let rows = footerRows[i];
          for(let i in footerColumns){
            tableFooter.push(rows[footerColumns[i]]);
          }
          excelData.push(tableFooter);
      }
      isFooterRow = true;
      isSummaryRow = true;
    }

    exportExcel(excelData, isFooterRow, headerRowCount, isSummaryRow, self);
}

function exportExcel(data, isFooterRow, headerRowCount, isSummaryRow, self){

      console.log('called 2');

      const XlsxPopulate = require('xlsx-populate');

      XlsxPopulate.fromBlankAsync()
          .then(workbook => {
              // Modify the workbook.

              console.log('called 3');

              workbook.sheet(0).cell("A1").value(data);

              let sheetName = 'BizOps App Report';
              workbook.sheet(0).name(sheetName);

                  var tbl_LastColumn_Index = data[0].length - 1;
                  var tbl_LastRow_Index = data.length;

                  //Getting first row and first col address
                  const tbl_FirstRow_FirstCell = workbook.sheet(0).cell(headerRowCount,1).address();
                  //Getting first row last col address
                  const tbl_FirstRow_LastCell = workbook.sheet(0).cell(headerRowCount,tbl_LastColumn_Index).address();
                  //Getting last row first col address
                  const tbl_LastRow_FirstCell = workbook.sheet(0).cell(tbl_LastRow_Index,1).address();
                  //Getting last row last col address
                  const tbl_LastRow_LastCell = workbook.sheet(0).cell(tbl_LastRow_Index, tbl_LastColumn_Index).address();

                  var headerRange = tbl_FirstRow_FirstCell+":"+tbl_FirstRow_LastCell;
                  var footerRange = tbl_LastRow_FirstCell+":"+tbl_LastRow_LastCell;
                  
                  //Setting cell styles
                  workbook.sheet(0).range(headerRange).style({"fill": "dddddd", "bold": true});

                  isFooterRow ? workbook.sheet(0).range(footerRange).style({"bold": true}) : '';

                  if(isSummaryRow){
                    const tbl_SecondLastRow_FirstCell = workbook.sheet(0).cell(tbl_LastRow_Index-1,1).address();
                    const tbl_SecondLastRow_LastCell = workbook.sheet(0).cell(tbl_LastRow_Index-1, tbl_LastColumn_Index).address();
                    const tbl_ThirdLastRow_FirstCell = workbook.sheet(0).cell(tbl_LastRow_Index-2,1).address();
                    const tbl_ThirdLastRow_LastCell = workbook.sheet(0).cell(tbl_LastRow_Index-2, tbl_LastColumn_Index).address();

                    var SecondLastFooterRange = tbl_SecondLastRow_FirstCell+":"+tbl_SecondLastRow_LastCell;
                    var ThirdLastFooterRange = tbl_ThirdLastRow_FirstCell+":"+tbl_ThirdLastRow_LastCell;

                    workbook.sheet(0).range(SecondLastFooterRange).style({"bold": true});
                    workbook.sheet(0).range(ThirdLastFooterRange).style({"bold": true});
                  }

                  workbook.outputAsync().then(function (blob) {
                    var fileName = self.$root.dataObj.reportTitle.replace(/\//g, '') + '-Report_' + self.$root.fn_getCurrentDateTimeString();
                    console.log(event)
                    console.log(fileName)
                    self.exportExcel = false;
                    var url = window.URL.createObjectURL(blob);
                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.href = url;
                    a.download = fileName + ".xlsx";
                    a.click();
                    window.URL.revokeObjectURL(url);
                    document.body.removeChild(a);
                });
          });
}

function prepareExcelForGSTPortal(dataSheets, self){

    let sheets = [];

    for(let j=0; j<dataSheets.length; j++){

        let headerRow1 = [dataSheets[j].reportDataObject.headerRow1];
        let headerRow2 = [dataSheets[j].reportDataObject.headerRow2];
        let headerRow3 = [dataSheets[j].reportDataObject.headerRow3];
    
        let tableHeader = [];
        let headerCols = dataSheets[j].reportDataObject.reportData.headerRow;

        let keyIndex = -1;
        let objLength = Object.keys(headerCols).length;
        for(let key in headerCols){
            keyIndex++;
            tableHeader.push(headerCols[key]);
            // pushing null to all remaining
            if(keyIndex < objLength - 1){
                headerRow1.push(null);
                headerRow2.push(null);
                headerRow3.push(null);
            }
        }

        var excelData = {};
        excelData.sheetName = dataSheets[j].otherData.sheetName;
        excelData.data = [];
        excelData.data.push(headerRow1);
        excelData.data.push(headerRow2);
        excelData.data.push(headerRow3);
        excelData.headerRowCount = 4;

        excelData.data.push(tableHeader);

        for(var i=0; i<dataSheets[j].reportDataObject.reportData.detailRows.length; i++){

            let tableRow = [];
            let item = dataSheets[j].reportDataObject.reportData.detailRows[i];

            if((dataSheets[j].otherData.sheetName == 'hsn(b2b)' || dataSheets[j].otherData.sheetName == 'hsn(b2c)') && item.unitQtyCode && item.unitQtyCode == 45){
              item.unitQtyCode = 'LTR-LITRES';
            }

            for(let key in headerCols){
                console.log(headerCols[key]+': '+item[key]);
                if(headerCols[key]=='Date' || key=='transactionDate' || key=='shippingBillDate' || key=='referenceTransactionDate'){
                    item[key] = item[key] ? self.fn_getIndianFormatDate(item[key]) : '';
                }
                tableRow.push(item[key]);
            }

            excelData.data.push(tableRow);

        }

        sheets.push(excelData);
    }

    exportGSTPortalExcel(sheets, self);
}

function exportGSTPortalExcel(sheetsDataArr, self){

    console.log('called 2');

    const XlsxPopulate = require('xlsx-populate');

    XlsxPopulate.fromBlankAsync()
        .then(workbook => {
            // Modify the workbook.
            console.log('called 3');
            for(let i=0; i<sheetsDataArr.length; i++){
                
                let sheetName = sheetsDataArr[i].sheetName.replace(/\//g, '');
                workbook.addSheet(sheetName, i);

                workbook.sheet(i).cell("A1").value(sheetsDataArr[i].data);

                var tbl_LastColumn_Index = sheetsDataArr[i].data[0].length;

                let alphabets = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
                for(let k=0; k<tbl_LastColumn_Index; k++){
                    let colValLength = workbook.sheet(i).cell(alphabets[k]+"4").value().length + 5;
                    workbook.sheet(i).column(alphabets[k]).width(colValLength);
                }

                for(let row=0; row<sheetsDataArr[i].data.length; row++){

                    for(let col=0; col<sheetsDataArr[i].data[row].length; col++){
                        
                        let colValue = sheetsDataArr[i].data[row][col];
                        
                        if(sheetsDataArr[i].sheetName != 'docs' && typeof(colValue) == 'number'){
                            let cellAddress = workbook.sheet(i).cell((row+1),(col+1)).address();
                            workbook.sheet(i).cell(cellAddress).style("numberFormat", "0.00");
                        }
                        
                        // if(self.$moment(colValue, "DD-MMM-YYYY", true).isValid()){  
                        //     let cellAddress = workbook.sheet(i).cell((row+1),(col+1)).address();
                        //     let cellValue = workbook.sheet(i).cell((row+1),(col+1)).value();
                        //     let dateObj = new Date(cellValue);
                        //     workbook.sheet(i).cell(cellAddress).value(dateObj).style("numberFormat", "dd-mmm-yyyy");
                        // }
                    }
                }
            }

            workbook.deleteSheet("Sheet1");
            workbook.activeSheet(0);

            workbook.outputAsync().then(function (blob) {

                var fileName = "GSTR-1_"+self.$root.CurrentBusiness.GSTNumber+"_"+self.$root.fn_getCurrentDateTimeString();
                // console.log(event)
                console.log(fileName);
                self.exportExcel = false;
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = url;
                a.download = fileName + ".xlsx";
                a.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);

                self.exportExcel = false;
            });

            
        });
}

</script>

<style>
  .drawer_left_btn{
    margin: 0 !important;
  }
  .drawer_right_btn,
  .dialog_right_btn{
    min-width: 60px !important;
  }
  .navigation-drawer{
    z-index: 99 !important;
    padding: 0 !important;
  }
  .navigation-drawer .filter_categories{
    height: 100%;
    overflow: auto;
  }
  .navigation-drawer .filter_categories .list__tile__action{
    color: rgb(153, 153, 153);
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-direction: inherit;
    align-items: center;
    display: block;
    text-align: right;
    padding: 14px 0px;
  }
  .overlay{
    z-index: 98;
  }
  .filterdialog{
    height: 100%;
    max-height: 100% !important;
    margin: 0 !important;
    position: absolute;
    right: 0;
  }
  .filtercard.card{ 
    height: 100% !important;
    overflow: hidden !important;
  }
  .filtercard.card .card__title,
  .custom_dates.card .card__title{
    padding: 0 !important;
  }
  .filtercard.card .card__text{
    height: 100%;
    padding: 0px;
  }
  .filtercard.card .card__text .radiogroup{
    padding: 10px 0px !important;
  }
  .filterdialog .list{
    padding: 0;
  }
  .filterdialog .customheader .list__tile{
    padding-right: 0;
  }
  .filterdialog .list .list__tile .list__tile__action{
    min-width: 40px;
  }
  .filter_dialog.list__tile .right_content{
    font-size:small;color:#1976d2;position:absolute;right:0;
  }
  #custom_overlay{
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0,0,0,0.4);
  }
  .checkbox_tile .list__tile{
    padding-top: 10px;
  }


  .dialog_search .card{
    height: 100% !important;
    overflow: hidden !important;
    background-color: #F0F0F0 !important;
  }
  .dialog_search .card__title{
    height: 48px;
    background-color: #fff;
    padding: 0;
  }
  .dialog_search .card__title .input-group{
    padding-right: 12px !important;
    padding-top: 0;
  }
  .input-group .input-group__input .icon{
    color: rgba(0,0,0,.54) !important;
  }
  .dialog_search .card__title .input-group .input-group__details{
    min-height: 16px !important;
    display: none;
  }
  .dialog_search .card__title .input-group .input-group__details:before,
  .dialog_search .card__title .input-group .input-group__details:after{
    display: none;
  }
  .dialog_search .card__text{
    padding: 0px;
    height: calc(100% - 58px);
    overflow: auto;
    margin-top: 8px;
    background-color: #fff;
  }
  .dialog_search .list{
    width: 100%;
    /*height: 100%;*/
    padding-top: 0;
  }
  .progress-linear{
    height: 2px !important;
    margin: 0 !important;
  }
  .card_text_msg{
    width: 100%;
      text-align: center;
      font-size: 16px;
  }
  .right-align{
    text-align: right !important;
  }
  /*#startdate, #enddate{
    visibility:hidden;position:absolute
  }*/
  .noresult{
    padding:16px;text-align:center
  }
  .select_options .radio-group{
    padding: 0;
  }
  .select_options .radio-group .input-group__input .radio{
    padding-bottom: 8px;
  }
  #btn:focus{
    outline: none;
  }
</style>